<template>
  <div class="print_tag_wapper ph16">
    <breadcrumb
      :title="$route.query.line || translateLang('main.sideBar.paibanResult')"
      :childTitle="translateLang('main.sideBar.printTag')"
      @goBackPage="$router.push({ path: '/newPaiban' })"
      class="breadcrumb-box"
    >
    </breadcrumb>

    <div class="header relative flex flex-cross--center pl16 bg-white">
      <span class="title fs16 color-o-9 bold">{{
        $t('main.sideBar.printTag')
      }}</span>
      <div class="select-tag flex">
        <span>{{ $t('common.filter') }}：</span>
        <el-select
          size="mini"
          v-model="cut_select_value"
          @change="siftChange"
          :disabled="isTagLoading"
        >
          <el-option
            v-for="it in select_options"
            :key="it.value"
            :label="it.label"
            :value="it.value"
          >
          </el-option>
        </el-select>
      </div>
      <a-progress
        status="active"
        v-if="isTagLoading"
        :percent="Math.round(cut_progress)"
        id="printTag_progress_span"
        :stroke-color="{
          '0%': '#108ee9',
          '100%': '#87d068',
        }"
        size="small"
        class="progress"
      />
      <span v-if="isTagLoading" class="ml15" style="color: red">
        {{ $t('printPage.genTagFile') }}
      </span>
      <div
        class="header-right absolute"
        @mouseenter="() => (isShowToolTip = true)"
        @mouseleave="() => (isShowToolTip = false)"
      >
        <el-tooltip
          :content="translateLang('printPage.waitGen')"
          placement="bottom"
          :value="(isCanDownLoading && isShowToolTip) || isLoadWaitting"
          enterable
          manual
        >
          <div class="print_btn">
            <a-checkbox
              class="mr20"
              v-if="!isWebToQt"
              v-model="isSendToEzSort"
              @change="handleChangeToEzSort"
              :value="true"
              :id="`print_tag_send_to_ezsort_head_checkbox`"
              >{{ $translateLang('发送至彩标') }}</a-checkbox
            >

            <a-button
              :disabled="isCanDownLoading || isLoadWaitting"
              :loading="export_loading"
              class="export-btn export-pdf-btn mr16"
              id="print_tag_pdf_btn"
              @click="exportPdf"
              >{{
                export_loading
                  ? export_loading_text
                  : translateLang('common.exportPDF')
              }}</a-button
            >
            <a-button
              :disabled="
                isCanDownLoading ||
                isLoadWaitting ||
                (gen_no_cut_tag &&
                  source_data.some((item) => item.isDesMaterialNoCut))
              "
              :loading="export_loading"
              class="export-btn mr16"
              id="print_tag_pic_btn"
              @click="exportImg"
              :class="{
                'disabled-btn':
                  print_color_tag &&
                  $store.state.ncSetting.labelImageFormatNew == 'bmp' &&
                  $store.state.ncSetting.bmp_color_style == 1,
              }"
              :title="
                gen_no_cut_tag &&
                source_data.some((item) => item.isDesMaterialNoCut)
                  ? $translateLang('已开启生成不下料板件标签，暂不支持导出图片')
                  : ''
              "
              >{{
                export_loading
                  ? export_loading_text
                  : translateLang('common.exportPic')
              }}
              <a-tooltip placement="top">
                <template slot="title">
                  <span>{{ translateLang('common.hoverTip') }}</span>
                </template>
                <img
                  src="@/assets/labelColor/error-circle.png"
                  alt=""
                  style="height: 16px; width: 16px"
                  class="ml6 mb3"
                  v-if="
                    print_color_tag &&
                    $store.state.ncSetting.labelImageFormatNew == 'bmp' &&
                    $store.state.ncSetting.bmp_color_style == 1
                  "
                />
              </a-tooltip>
            </a-button>

            <a-button
              :disabled="isCanDownLoading || isLoadWaitting"
              :loading="export_loading"
              class="export-btn print-tag-btn"
              id="print_tag_export_btn"
              @click="printPre"
            >
              {{
                export_loading
                  ? export_loading_text
                  : translateLang('printPage.print')
              }}
              <img
                src="@/assets/labelColor/error-circle.png"
                alt=""
                style="height: 16px; width: 16px"
                class="ml6 mb4 print-tag-img"
                v-show="print_color_tag"
              />
              <div class="absolute print-tip" v-show="print_color_tag">
                <span class="color-tip" style="color: #000000e6">{{
                  translateLang('common.checkColorPrint')
                }}</span>
              </div>
            </a-button>
          </div>
        </el-tooltip>
      </div>
    </div>

    <a-spin
      :tip="mainLoadingTip"
      :spinning="template_loading || isLoadFont"
      :delayTime="100"
    >
      <div class="com_content relative">
        <!-- 标签模板 -->
        <div class="tag_setTem_wap y-auto">
          <div class="tag_tem_wap y-auto">
            <p class="title">{{ $t('common.tagTemp') }}</p>
            <div class="tag_tem_list pr15 y-auto" ref="tagTempListRef">
              <div
                v-for="(template, index) in template_list"
                :key="index"
                class="template-item cursor-pointer color-o-9"
                :class="{ active: template.id === active_template_id }"
                @click="chooseTemplate(template, true)"
              >
                <a-tooltip>
                  <template #title v-if="template.name.length > 17">{{
                    template.name
                  }}</template>
                  <span
                    :id="`template_${index}`"
                    class="template-name w100 overflow-hidden ellipsis"
                    >{{
                      index
                        ? template.name
                        : translateLang('printPage.defaultTemplate')
                    }}</span
                  >
                </a-tooltip>
                <a-popover
                  v-if="template.id"
                  trigger="hover"
                  placement="rightTop"
                  overlayClassName="tag-template-action-popover"
                >
                  <template #content>
                    <div class="template-action-popover">
                      <div
                        class="template-action-item"
                        @click.stop="editTemplate(template)"
                      >
                        <a-icon type="edit" />
                        <span>{{ $translateLang('编辑模板') }}</span>
                      </div>
                      <div
                        class="template-action-item template-action-item--danger"
                        @click.stop="deleteTemplate(template)"
                      >
                        <a-icon type="delete" />
                        <span>{{ $translateLang('删除模板') }}</span>
                      </div>
                      <div
                        class="template-action-item"
                        @click.stop="copyTemplateRenderUrl(template)"
                      >
                        <a-icon type="link" />
                        <span>{{ $translateLang('复制模板链接') }}</span>
                      </div>
                    </div>
                  </template>
                  <span
                    class="template-action-btn"
                    @click.stop
                    :title="$translateLang('更多操作')"
                  >
                    <a-icon type="ellipsis" />
                  </span>
                </a-popover>
              </div>
            </div>
            <div class="edit_addTem mt10">
              <a-button
                style="width: 70px"
                @click="addTemplate"
                id="print_tag_add_template_btn"
                class="pt5"
                :title="translateLang('common.add')"
                ><span s class="w100 ellipsis inline-block">{{
                  $t('common.add')
                }}</span></a-button
              >
              <a-tooltip placement="top">
                <template #title>
                  <span>{{
                    $translateLang('粘贴模板链接后，可将模板导入到当前列表中')
                  }}</span>
                </template>
                <a-button
                  style="margin-left: 6px; width: 88px"
                  class="pt5"
                  @click="openTemplateImportModal"
                >
                  <span class="w100 ellipsis inline-block">{{
                    $translateLang('导入模板')
                  }}</span>
                </a-button>
              </a-tooltip>
            </div>
          </div>
          <div class="tag_set">
            <p class="title">
              <span
                class="inline-block ellipsis"
                style="max-width: 85px"
                :title="translateLang('printPage.tagSetting')"
                >{{ $t('printPage.tagSetting') }}</span
              >
              <span
                class="fs12 color-o-4 ml5 inline-block ellipsis text-style"
                style="width: 170px"
                :title="translateLang('printPage.rememberSetting')"
                >{{ $t('printPage.rememberSetting') }}</span
              >
            </p>
            <div class="tag_gen">
              <span> {{ translateLang('printPage.genTag') }} </span>
              <a-checkbox
                @change="handleAll"
                :indeterminate="indeterminate"
                :checked="checkAll"
              >
                {{ translateLang('printPage.all') }}
              </a-checkbox>
            </div>
            <div class="tag-tabs mt10">
              <a-tabs
                size="small"
                type="card"
                :animated="true"
                @change="changeTagTabs"
              >
                <a-tab-pane :tab="$translateLang('常规原片标签')" key="normal">
                  <a-checkbox
                    @change="handleAllForNormal"
                    :indeterminate="indeterminateForNor"
                    :checked="checkAllForNor"
                    >{{ translateLang('printPage.all') }}</a-checkbox
                  >
                  <p>
                    <a-checkbox
                      v-model="gen_small_plank_tag"
                      @change="changeGenSmallPlankTag"
                      ><span
                        class="inline-block ellipsis text-style"
                        :title="translateLang('printPage.genPartTag')"
                        >{{ $translateLang('生成小板标签') }}
                      </span></a-checkbox
                    >
                  </p>
                  <p>
                    <a-checkbox
                      id="printTag_gen_cutingTag_checkbox"
                      v-model="cut_need_lave"
                      @change="changeCutNeedLave"
                      ><span
                        id="printTag_gen_cutingTag_checkbox_label"
                        class="inline-block ellipsis text-style"
                        :title="$translateLang('生成裁剪余料板件标签')"
                        >{{ $translateLang('生成裁剪余料板件标签') }}</span
                      ></a-checkbox
                    >
                  </p>
                  <p>
                    <a-checkbox
                      v-model="need_lave"
                      @change="changeNeedLave"
                      id="printTag_gen_surplusTag_checkbox"
                      ><span
                        id="printTag_gen_surplusTag_checkbox_label"
                        class="inline-block ellipsis text-style"
                        :title="$translateLang('生成余料板件标签')"
                        >{{ $translateLang('生成余料板件标签') }}</span
                      ></a-checkbox
                    >
                  </p>
                  <p v-if="need_lave">
                    <a-checkbox
                      v-model="is_lave_tag_end"
                      @change="changeCutLaveEnd"
                      id="printTag_cut_lave_end_checkbox"
                      ><span
                        id="printTag_cut_lave_end_checkbox_label"
                        class="inline-block ellipsis text-style"
                        :title="translateLang('printPage.cutLaveEnd')"
                        >{{ $t('printPage.cutLaveEnd') }}</span
                      ></a-checkbox
                    >
                  </p>

                  <p>
                    <a-checkbox
                      v-model="gen_big_plank_tag"
                      @change="changeGenBigPlankTag"
                      >{{ $translateLang('生成大板标签') }}
                    </a-checkbox>
                  </p>
                </a-tab-pane>
                <a-tab-pane :tab="$translateLang('余料大板标签')" key="surplus">
                  <a-checkbox
                    @change="handleAllForSurplus"
                    :indeterminate="indeterminateForSur"
                    :checked="checkAllForSur"
                    >{{ translateLang('printPage.all') }}</a-checkbox
                  >
                  <p>
                    <a-checkbox
                      v-model="gen_small_plank_tag_surplus"
                      @change="changeGenSmallPlankTag"
                      ><span
                        class="inline-block ellipsis text-style"
                        :title="translateLang('printPage.genPartTag')"
                        >{{ $t('printPage.genPartTag') }}
                      </span></a-checkbox
                    >
                  </p>
                  <p>
                    <a-checkbox
                      id="printTag_gen_cutingTag_checkbox"
                      v-model="cut_need_lave_surplus"
                      @change="changeCutNeedLave"
                      ><span
                        id="printTag_gen_cutingTag_checkbox_label"
                        class="inline-block ellipsis text-style"
                        :title="$translateLang('生成裁剪余料板件标签')"
                        >{{ $translateLang('生成裁剪余料板件标签') }}</span
                      ></a-checkbox
                    >
                  </p>
                  <p>
                    <a-checkbox
                      v-model="need_lave_surplus"
                      @change="changeNeedLave"
                      id="printTag_gen_surplusTag_checkbox"
                      ><span
                        id="printTag_gen_surplusTag_checkbox_label"
                        class="inline-block ellipsis text-style"
                        :title="$translateLang('生成余料板件标签')"
                        >{{ $translateLang('生成余料板件标签') }}</span
                      ></a-checkbox
                    >
                  </p>

                  <p v-if="need_lave_surplus">
                    <a-checkbox
                      v-model="is_lave_tag_end_sur"
                      @change="changeCutLaveEnd"
                      id="printTag_cut_lave_end_checkbox"
                      ><span
                        id="printTag_cut_lave_end_checkbox_label"
                        class="inline-block ellipsis text-style"
                        :title="translateLang('printPage.cutLaveEnd')"
                        >{{ $t('printPage.cutLaveEnd') }}</span
                      ></a-checkbox
                    >
                  </p>
                  <p>
                    <a-checkbox
                      v-model="gen_big_plank_surplus_tag"
                      id="printTag_gen_plankTag_checkbox"
                      @change="changeGenBigPlankTag"
                      >{{ $translateLang('生成大板标签') }}
                    </a-checkbox>
                  </p>
                </a-tab-pane>
              </a-tabs>
              <div style="height: 140px">
                <a-checkbox
                  v-model="gen_no_cut_tag"
                  @change="handleChangeNoCutTag"
                  id="printTag_gen_no_cut_tag_checkbox"
                  ><span
                    class="inline-block ellipsis text-style"
                    :title="$translateLang('生成不下料板件标签')"
                    >{{ $translateLang('生成不下料板件标签') }}</span
                  ></a-checkbox
                >
                <a-checkbox
                  v-model="isGenNcSuffix"
                  @change="handleChangeNCSuffix"
                  id="printTag_suffix_checkbox"
                  ><span
                    class="inline-block ellipsis text-style"
                    :title="translateLang('printPage.genPlankSuffix')"
                    >{{ $translateLang('大板标签生成下料文件名后缀') }}</span
                  ></a-checkbox
                >
                <div class="label-position mt6" @click.stop.prevent="() => {}">
                  <span
                    class="inline-block text-style ellipsis"
                    style="max-width: 52px"
                    :title="translateLang('printPage.tagPosition')"
                    >{{ $t('printPage.tagPosition') }}</span
                  >
                  <span
                    class="color-o-4 inline-block text-style ellipsis"
                    style="max-width: 170px"
                    :title="translateLang('printPage.tagPositionTip')"
                    >{{ $t('printPage.tagPositionTip') }}</span
                  >
                  <div class="flex mt5">
                    <div
                      class="coord-box flex flex-cross--center br3 pl8 mr12 mt2"
                    >
                      <span
                        class="fs12 color-o-4 pt1 ellipsis inline-block"
                        style="max-width: 32px"
                        :title="translateLang('printPage.Xposition')"
                        >{{ $t('printPage.Xposition') }}</span
                      >
                      <a-input-number
                        v-model="xCoordinate"
                        :min="-1000"
                        :max="1000"
                        :step="1"
                        :precision="0"
                        :disabled="!gen_big_plank_tag"
                        style="width: 62px; height: 24px"
                        @change="handleXChange"
                        id="printTag2_xCoordinate_input"
                      />
                    </div>
                    <div class="coord-box flex flex-cross--center br3 pl8 mt2">
                      <span
                        class="fs12 color-o-4 pt1 ellipsis inline-block"
                        style="max-width: 32px"
                        :title="translateLang('printPage.Yposition')"
                        >{{ $t('printPage.Yposition') }}</span
                      >
                      <a-input-number
                        v-model="yCoordinate"
                        :min="-1000"
                        :max="1000"
                        :step="1"
                        :precision="0"
                        :disabled="!gen_big_plank_tag"
                        style="width: 62px; height: 24px"
                        @change="handleYChange"
                        id="printTag2_yCoordinate_input"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <p>
                <a-checkbox
                  v-model="jx_checked"
                  @change="changeJxChecked"
                  id="printTag2_jx_checkbox"
                >
                  <span
                    class="inline-block ellipsis text-style"
                    :title="translateLang('printPage.arrangeMirror')"
                    id="printTag2_jx_span"
                    >{{ $t('printPage.arrangeMirror') }}</span
                  ></a-checkbox
                >
              </p>
              <p>
                <a-checkbox
                  v-model="five_six_dir"
                  @change="changeFiveSixDir"
                  :disabled="isCustomSixSideDrillPlankBase"
                  id="printTag2_five_six_dir_checkbox"
                  ><span
                    class="inline-block ellipsis text-style"
                    :title="translateLang('printPage.arrangeMirror')"
                    id="printTag2_five_six_dir_span"
                    >{{ $t('printPage.drillPlankBase') }}</span
                  ></a-checkbox
                >
              </p>
            </div>

            <div class="tag_sort_check">
              <p
                class="fs14 color-o-9 mb5 ellipsis text-style"
                :title="translateLang('printPage.suitAuto')"
                style="width: 250px"
              >
                {{ $t('printPage.suitAuto') }}
              </p>
              <a-radio-group
                name="radioGroup"
                v-model="sort_value"
                class="ml20 flex"
                style="width: 220px"
                @change="changeSortValue"
              >
                <a-radio
                  :value="1"
                  v-bp="'tag:tag_sort_default'"
                  id="printTag2_default_radio"
                  ><span
                    class="inline-block ellipsis text-style"
                    style="width: 28px"
                    :title="translateLang('printPage.default')"
                    id="printTag2_default_span"
                    >{{ $t('printPage.default') }}</span
                  ></a-radio
                >
                <a-radio
                  :value="2"
                  v-bp="'tag:tag_sort_up'"
                  id="printTag2_up_radio"
                  ><span
                    class="inline-block ellipsis text-style"
                    style="width: 42px"
                    :title="translateLang('printPage.up')"
                    id="printTag2_up_span"
                    >{{ $t('printPage.up') }}↑</span
                  ></a-radio
                >
                <a-radio
                  :value="3"
                  v-bp="'tag:tag_sort_down'"
                  id="printTag2_down_radio"
                  ><span
                    class="inline-block ellipsis text-style"
                    style="width: 42px"
                    :title="translateLang('printPage.down')"
                    id="printTag2_down_span"
                    >{{ $t('printPage.down') }}↓</span
                  ></a-radio
                >
              </a-radio-group>
            </div>

            <!-- 生成彩色标签 -->
            <div class="tag_color_check">
              <a-checkbox
                v-model="print_color_tag"
                @change="handleChangeColorTag"
                :disabled="gen_part_color_revert"
              >
                <span
                  class="inline-block ellipsis text-style"
                  :title="translateLang('printPage.colorLabel')"
                  >{{ $t('printPage.colorLabel') }}
                  <img
                    src="@/assets/labelColor/error-circle.png"
                    alt=""
                    id="parintTag2-error-circle"
                    style="width: 16px; height: 16px"
                    class="error-circle"
                  />
                </span>
              </a-checkbox>
              <!-- 彩色标签hover时展示提示 -->
              <div
                class="label-color-pop p16 absolute"
                id="printTag2-color-pop"
              >
                <p class="label-color-phead mb16">
                  {{ translateLang('common.colorRules') }}
                </p>
                <!-- 遍历 -->
                <div
                  v-for="(item, index) in colorTagTips"
                  :key="index"
                  class="flex"
                >
                  <div class="mb16">
                    <p class="label-color-phead label-color-title mb6">
                      {{ translateLang(item.title) }}
                    </p>
                    <span class="fs12 label-color-span"
                      >{{ translateLang('common.greyPart')
                      }}<span style="color: #e34d59">{{
                        `${translateLang(item.title)}${translateLang(
                          'common.region'
                        )}`
                      }}</span
                      >，
                      <span v-if="item.id !== 4">
                        {{
                          $t('common.notSame', {
                            regionName: translateLang(item.title),
                          })
                        }}</span
                      >
                      <span v-else>
                        {{ translateLang('common.doorTip') }}
                      </span>
                    </span>
                  </div>
                  <img :src="item.imgUrl" alt="" class="label-color-img" />
                </div>
              </div>
            </div>
            <div class="mb16">
              <a-checkbox
                v-model="gen_part_color_revert"
                @change="handleChangeColorRevert"
                :disabled="print_color_tag"
              >
                <new-content :is-new-content="false">
                  <span
                    class="inline-block ellipsis text-style"
                    :title="$translateLang('生成小板反色标签')"
                    style="max-width: 180px"
                    >{{ $translateLang('生成小板反色标签') }}
                  </span>
                </new-content>
              </a-checkbox>
            </div>
            <div class="mb16 relative">
              <a-checkbox
                v-model="roomCabinetPanelNameDisplay"
                @change="handleChangeDualLanguageTags"
              >
                <div
                  class="text-style flex flex-cross--center"
                  style="max-width: 180px"
                >
                  <g-paid-feature
                    :permission-keys="['room_cabinet_panel_name_display']"
                    :isOverseasPass="isOverseas"
                  >
                    <span
                      class="flex-box--0"
                      :title="translateLang('生成中英双语标签')"
                    >
                      {{ translateLang('生成中英双语标签') }}
                    </span>
                  </g-paid-feature>
                </div>
              </a-checkbox>
              <!-- 双语标签选项 -->
              <div v-show="roomCabinetPanelNameDisplay">
                <div>{{ translateLang('生效数据源') }}</div>
                <a-select
                  v-model="dualLanguageTags"
                  mode="multiple"
                  style="width: 250px"
                  :placeholder="$translateLang('请选择')"
                  :options="dualLanguageOptions"
                  @change="handleChangeDispaly"
                >
                </a-select>
              </div>
            </div>
          </div>
          <div class="print_set">
            <p class="title">
              <span
                class="inline-block ellipsis"
                style="max-width: 85px"
                :title="translateLang('printPage.printSetting')"
                >{{ $t('printPage.printSetting') }}</span
              >
              <span
                class="fs12 color-o-4 ml5 inline-block ellipsis text-style"
                style="width: 170px"
                :title="translateLang('printPage.rememberSetting')"
                >{{ $t('printPage.rememberSetting') }}</span
              >
            </p>
            <div>
              <p class="mb12 color-0">
                <span
                  class="text-style ellipsis inline-block"
                  style="max-width: 58px"
                  :title="translateLang('printPage.oneToMore')"
                  >{{ $t('printPage.oneToMore') }}</span
                >：<span
                  class="inline-block ellipsis text-style"
                  :title="translateLang('printPage.perPage')"
                  >{{ $t('printPage.perPage') }}</span
                >
                <a-input-number
                  v-model="print_setting.cols"
                  :min="1"
                  :max="10"
                  :step="1"
                  :precision="0"
                  style="width: 60px; margin-right: 5px"
                  @change="handleColsChange"
                  id="printTag2_cols_input"
                />{{ $t('printPage.coloumn') }}
              </p>
              <p class="mb12 color-0">
                <span
                  class="text-style ellipsis inline-block"
                  style="max-width: 58px"
                  :title="translateLang('printPage.tagMargin')"
                  >{{ $t('printPage.tagMargin') }}</span
                >：<span
                  class="text-style ellipsis inline-block"
                  :title="translateLang('printPage.coloumnMargin')"
                  >{{ $t('printPage.coloumnMargin') }}</span
                >
                <a-input-number
                  v-model="print_setting.labelColumnGap"
                  :min="0"
                  :max="999.99"
                  :step="1"
                  style="width: 80px; margin-right: 5px"
                  @change="handleColSpaceChange"
                  id="printTag2_labelColumnGap_input"
                />mm
              </p>
              <p class="flex flex-cross--center mb10 color-0">
                <span
                  class="text-style ellipsis inline-block"
                  style="max-width: 58px"
                  :title="translateLang('printPage.specialMark')"
                  >{{ $t('printPage.specialMark') }}</span
                >：
                <a-tooltip>
                  <template #title>
                    <span>{{
                      $translateLang('BMP格式的图片需要选择真彩才支持透明度')
                    }}</span>
                  </template>
                  <span
                    class="text-style ellipsis inline-block"
                    :title="translateLang('printPage.opacity')"
                    >{{ $t('printPage.opacity') }}</span
                  >
                </a-tooltip>
                <a-slider
                  v-model="print_setting.opacity"
                  :min="0"
                  :max="1"
                  :step="0.01"
                  class="mr5"
                  style="width: 88px"
                  :disabled="$store.state.isExistcusSpecialTag"
                  @change="handleConfigSlider('opacity')"
                />
                <span>{{ print_setting.opacity }}</span>
              </p>
              <p class="flex flex-cross--center mb10 color-0">
                <span
                  class="text-style ellipsis inline-block"
                  style="max-width: 58px"
                  :title="translateLang('printPage.suite')"
                  >{{ $t('printPage.suite') }}</span
                >
                <a-switch
                  size="small"
                  v-model:checked="print_setting.sizeAuto"
                  class="ml5 mr3"
                  :disabled="$store.state.isExistcusSpecialTag"
                  @change="handleConfigSlider('sizeAuto')"
                  id="printTag2_sizeAuto_switch"
                />
                {{ $t('printPage.size') }}
                <a-slider
                  v-model="print_setting.size"
                  :disabled="
                    $store.state.isExistcusSpecialTag || print_setting.sizeAuto
                  "
                  :min="0"
                  :max="1"
                  :step="0.01"
                  class="mr5"
                  style="width: 88px"
                  @change="handleConfigSlider"
                  id="printTag2_size_slider"
                />
                <span>{{ print_setting.size }}</span>
              </p>
            </div>
          </div>
        </div>

        <div
          v-if="
            !gen_small_plank_tag &&
            !tag_svg_list.length &&
            (!isNewTagDraw || !tagList.length)
          "
          class="tag_canvas_wap tag_canvas_tip"
        >
          {{ $translateLang('未开启生成小板标签，请在左侧勾选') }}
        </div>
        <!-- 标签列表 -->
        <div
          v-loading="isreloading || isLoadWaitting"
          class="tag_canvas_wap"
          :class="renderDataList.length > 5 ? 'tag_canvas_wap--height' : ''"
          v-else
        >
          <div
            v-if="
              !tag_svg_list.length &&
              renderDataList.length &&
              (isNewTagDraw ? !tagList.length && isTagLoading : true)
            "
            class="loading_page-wrap"
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 100%;
            "
          >
            <i
              class="el-icon-loading"
              style="color: #18a8c7; font-size: 25px"
            ></i>
          </div>
          <div
            :style="{
              width: `${tag_canvas_wap_width.total_width}px`,
            }"
          >
            <!-- 使用base64时 -->
            <div
              class="w100 flex flex-wrap print_tag_list"
              style="flex-wrap: wrap"
              v-if="isNewTagDraw"
            >
              <div v-for="(item, idx) in tagList" :key="idx" class="print_mark">
                <div
                  style="margin-bottom: 20px"
                  class="render_svg_item"
                  :id="`printTag2_render_img_item_${idx + 1}`"
                  :style="{
                    'margin-right': `${
                      (Number(idx) + 1) % print_setting.cols
                        ? tag_canvas_wap_width.space
                        : 0
                    }px`,
                    marginBottom: '20px',
                    width: `${
                      (tag_canvas_wap_width.total_width -
                        tag_canvas_wap_width.space * (print_setting.cols - 1)) /
                      print_setting.cols
                    }px`,
                  }"
                >
                  <img :src="item.src" alt="" width="100%" />
                </div>
              </div>
            </div>

            <div
              v-else
              class="tag_list print_tag_list"
              v-infinite-scroll="loadTagList"
              :infinite-scroll-disabled="
                useLoadMore ? disabledTagList : () => {}
              "
              :infinite-scroll-immediate="false"
            >
              <div
                v-for="(item, idx) in tag_svg_list"
                :key="idx"
                :data-idx="idx"
                class="print_mark"
              >
                <div
                  v-if="idx < tagListSourceData.length"
                  style="margin-bottom: 20px"
                  class="render_svg_item"
                  :style="{
                    'margin-right': `${
                      (Number(idx) + 1) % print_setting.cols
                        ? tag_canvas_wap_width.space
                        : 0
                    }px`,
                  }"
                  :id="`printTag2_render_svg_item_${idx + 1}`"
                  v-html="item"
                ></div>
                <div
                  v-else
                  style="margin-bottom: 20px"
                  class="render_svg_item"
                  :id="`printTag2_render_svg_item_${idx + 1}`"
                  :style="{
                    'margin-right': `${
                      (tagListSourceData.length +
                        (idx - tagListSourceData.length) +
                        1) %
                      print_setting.cols
                        ? tag_canvas_wap_width.space
                        : 0
                    }px`,
                  }"
                  v-html="item"
                ></div>
              </div>
              <!-- 占位用，处理用滚轮滚动时，加载更多的时候，loading没有显示完整的问题 -->
              <p
                class="place"
                v-if="!isTagLoading && !isNoMoreTag"
                style="width: 100%; height: 21px"
              ></p>
            </div>

            <p
              v-if="
                (tag_svg_list.length || (isNewTagDraw && tagList.length)) &&
                isTagLoading
              "
            >
              <i class="el-icon-loading"></i>
              {{ $t('arrangedPage.dataLoading') }}
            </p>
            <p
              v-if="
                (tag_svg_list.length || (isNewTagDraw && tagList.length)) &&
                isNoMoreTag
              "
            >
              {{ $t('printPage.noMore') }}
            </p>
            <!-- 使用base64时 -->
            <!-- <img
              v-for="(item, idx) in tag_svg_list"
              :key="idx"
              :src="item"
              alt=""
              style="width: 100%; margin-bottom: 20px"
              :style="{
                'margin-right': `${
                  (Number(idx) + 1) % print_setting.cols
                    ? tag_canvas_wap_width.space
                    : 0
                }px`,
              }"
            /> -->
            <!-- <template v-if="need_lave">
              <div
                v-for="(svg, index) in lave_svg_list"
                :key="`lave_${index}`"
                style="margin-bottom: 20px"
                class="render_svg_item"
                :style="{
                  'margin-right': `${
                    (Object.keys(tag_svg_list).length + index + 1) %
                    print_setting.cols
                      ? tag_canvas_wap_width.space
                      : 0
                  }px`,
                }"
                v-html="svg"
              ></div>
            </template> -->

            <!-- 使用base64时 -->
            <!-- <img
              v-for="(item, idx) in lave_svg_list"
              :key="idx"
              :src="item"
              alt=""
              style="width: 100%; margin-bottom: 20px"
              :style="{
                'margin-right': `${
                  (Object.keys(tag_svg_list).length + index + 1) %
                  print_setting.cols
                    ? tag_canvas_wap_width.space
                    : 0
                }px`,
              }"
            /> -->
          </div>
        </div>

        <!-- 打印 -->

        <div class="tag_print_box ml12">
          <div class="text-content">
            <span>{{ $translateLang('导出语言') }}</span>
            ：
            <a-select
              style="width: 160px"
              v-model="exportLanguage"
              id="printTag2_export_language_select"
              @change="handleChangeExportLanguage"
            >
              <a-select-option
                :value="item.value"
                v-for="item in exportLanguageOptions"
                :key="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
            <!-- <span
          class="fs14"
          style="color: #e34d59"
          v-if="exportLanguage !== 'zh' && exportLanguage"
          >（{{ $translateLang('注意：部分文字信息导出pdf无法翻译') }}）</span
        > -->
          </div>
          <!-- 占位元素 -->
          <div class="region"></div>
          <div class="explain">
            <div class="legend">
              <div class="title bold mb10 fs12 color-0">
                {{ $t('arrangedPage.picSymble') }}
              </div>
              <div class="legend-box">
                <ul>
                  <li class="mb10 flex flex-cross--center">
                    <img
                      class="icon"
                      src="@/assets/icon/caret-left-small@2x.png"
                      alt=""
                    />
                    <span class="pl9 color-0">{{
                      $t('printPage.lightSide')
                    }}</span>
                  </li>
                  <li class="mb10">
                    <span class="pl5 fs14 color-0">{{
                      $t('printPage.front')
                    }}</span>
                    <span class="pl5 pl14 color-0">{{
                      $t('printPage.locFrontSide')
                    }}</span>
                  </li>
                  <li class="mb17">
                    <span class="open icon fs14 color-0">{{
                      $t('printPage.open')
                    }}</span>
                    <span class="pl9 color-0">{{
                      $t('printPage.openSide')
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="tip fs12 color-o-4" v-if="!inQt">
              {{ $t('printPage.extraTip') }}
            </div>
          </div>
        </div>
      </div>
    </a-spin>
    <!-- 标签画布 -->
    <canvas
      id="tag"
      style="position: fixed; top: 0; left: 0; z-index: -100; opacity: 1"
    ></canvas>
    <!-- 打印、导出使用画布，为获取canvas宽度，不能使用none -->
    <canvas
      id="print-tag"
      style="position: fixed; top: 0; left: 0; z-index: -100; opacity: 1"
    ></canvas>
    <!-- 导出图片截图使用，不能使用none -->
    <div
      id="tag-image"
      style="position: fixed; top: 0; left: 0; z-index: -100"
    ></div>

    <loading
      :finish_percent="finish_percent"
      :loading="showLoading"
      :isTimeOut="isTimeOut"
      :isWebToQt="isNewTagDraw"
      :loadingTitle="translateLang('main.sideBar.printTag')"
      type="3"
      :text="
        isPrintFlag && showLoading
          ? translateLang('common.dataLoading')
          : translateLang('printPage.tagDownloading')
      "
    ></loading>
    <g-base-modal
      :visible="isVisible"
      v-if="isVisible"
      @ok="handleDelateTemplate"
      :contain="translateLang('printPage.deleteTip')"
      @cancel="isVisible = false"
    >
    </g-base-modal>
    <a-modal
      :visible="showImportTemplateModal"
      title="导入标签模板链接"
      :confirmLoading="importTemplateLoading"
      @ok="handleImportTemplate"
      @cancel="resetImportTemplateState"
      destroyOnClose
    >
      <div class="import-template-modal">
        <div class="import-template-tip">
          {{
            $translateLang(
              '将标签模板链接地址粘贴至下方输入框中，即可完成模板导入'
            )
          }}
        </div>
        <a-input
          v-model="importTemplateUrl"
          :placeholder="$translateLang('请输入模板链接')"
          @change="importTemplateError = ''"
        />
        <div v-if="importTemplateError" class="import-template-error">
          {{ importTemplateError }}
        </div>
      </div>
    </a-modal>
    <!-- 本地直接下载nc文件所使用的目录被删除提示的弹窗 -->
    <g-folder-choose-modal
      :cb="exportImg"
      ref="folderChooseModalRef"
    ></g-folder-choose-modal>
  </div>
</template>

<script>
import { fetchUserPermission } from '@/apis/auth'
import { buryPoint } from '@/apis/common/buryPoint'
import { fetchGetProductionNcSetting } from '@/apis/materialList'
import { getPaibanBatch } from '@/apis/paiban/index'
import { createAxiosWithGlobal, httpRequest } from '@/apis/request'
import { getSurplusList } from '@/apis/surplusManage'
import { fetchPlankReference, getSpecialRemarks } from '@/apis/tag/index'
import { getLabelTranslation } from '@/apis/translateApis'
import door from '@/assets/labelColor/door.png'
import modular from '@/assets/labelColor/modular.png'
import order from '@/assets/labelColor/order.png'
import room from '@/assets/labelColor/room.png'
import loading from '@/components/common/loading'
import GBaseModal from '@/components/g-base-modal.vue'
import GFolderChooseModal from '@/components/g-folder-choose-modal.vue'
import GPaidFeature from '@/components/g-paid-feature.vue'
import newContent from '@/components/newContent.vue'
import { showSyncModal } from '@/components/syncmodal'
import breadcrumb from '@/components/topBreadCrumb.vue'
import { plankMapState } from '@/constants'
import { initGuiguiTranslate } from '@/data/i18n/guigui'
import {
  additionalTranslateMap,
  escapeTemplate,
  languageMap,
} from '@/data/i18n/json/templateMap'
import { translateLang } from '@/data/i18n/translateLang'
import Lang from '@/store/modules/lang'
import { updateLocalPreference } from '@/store/modules/preferencesSetting'
import { deepCopy, judgeIsMergeFrameDoor } from '@/util/LayoutFuncs'
import { checkIsOnlyProcessHoleSlotByPaibanData } from '@/util/LayoutTool'
import { changeDataStartPoint } from '@/util/NCGenerator'
import { pickNcPartFields } from '@/util/NcFileRelated'
import { bigPlankTemp } from '@/util/bigPlankTemp'
import { EventBusKey } from '@/util/bus'
import EventBus from '@/util/bus'
import { copyText } from '@/util/common'
import { dealHighlightMatCode, translate } from '@/util/commonFun'
import {
  buryPointApi,
  compare,
  fourTrimEdge,
  getOriginRect,
  modalMsg,
  splitTime,
} from '@/util/commonFuncs.js'
import { transformToEzSort } from '@/util/connect-color-label/transform'
import { JxTagData, countTagDataByDir } from '@/util/countTagData'
import {
  countSameSizeBoard,
  createLaveTag,
  createTag,
  roomNameToChartMap,
} from '@/util/createTag'
import { getEdgeTypeWithRect } from '@/util/createTag'
import { dealLshapeTurnPoints } from '@/util/dealPaibanData'
// import html2canvas from 'html2canvas'
import defaultTagData, {
  defaultPaibanData,
  ensureTagDataDefaults,
} from '@/util/defaultTagData'
import { getDeviceXDPI, mmToPx } from '@/util/exportFuncs'
import { convertJpegToBmp } from '@/util/file/convert'
import { savaFileToDisk } from '@/util/fileSystem/generateFile'
import { exportBmp1Bit } from '@/util/jimp'
import JSZip from '@/util/jszip'
import {
  appendSubTagFileNameSuffix,
  dealDrawDataForTag,
  dealFileArrLabel,
  dealFileArrfunc,
  deepMapsToPlain,
  generateTagFile,
  getTagDrawTemplate,
  isBlankTagSvg,
  isPartTagType,
  plankOrderCompensationDigits,
  prefixInteger,
  pushSmallPlankTagWithSub,
  rollOverTag,
  validateSubTagPerForExport,
} from '@/util/productionDataGenerate/tagDataGenerate'
import { saveDataToOSS } from '@/util/saveFile'
import {
  genFirstLevelFileName,
  getGraghEdge,
  getSurplusSize,
  judgeIsGenerateLaveTag,
} from '@/util/tag'
import { fontFamilyMap } from '@/util/tag/pdf-draw'
import { jsPdfTool } from '@/util/tag/pdfFont'
import { initFabricNeedFont } from '@/util/tag/tag-font'
import {
  isSpecialBigPlank,
  isSurplusBigPlank,
} from '@/views/newPaiban/util/layoutDataDeal'
import { uploadFiles as ossUploadFiles } from '@/views/newPaiban/util/uploadFiles'
import bus from '@bus'
import domtoimage from 'dom-to-image'
import FileSaver from 'file-saver'
import jsPDF from 'jspdf'
import { cloneDeep, debounce } from 'lodash'
import { nanoid } from 'nanoid'
import { mapMutations, mapState } from 'vuex'

import { getDualLanguageOptions } from './data'
import { isEqual } from './utils/compare'
import { getSvgListToPdfJSBinary } from './utils/createPdf'

// 用于透明度设置防抖
let timer = null
// 大板补偿序号 默认1
const defaultStockNumOffset = 1
const exportLanguageOptions = [
  {
    label: '中文(Chinese)',
    value: 'zh',
  },
  {
    label: '繁体中文(Traditional Chinese)',
    value: 'zh_hant',
  },
  {
    label: '英文(English)',
    value: 'en',
  },
  { label: '越南语(Tiếng Việt)', value: 'vi' },
  { label: '泰语(ภาษาไทย)', value: 'th' },
  { label: '印尼语(Bahasa Indonesia)', value: 'id' },
  { label: '维语(ئۇيغۇر تىلى)', value: 'ug' },
  { label: '俄语(русский язык)', value: 'ru' },
  { label: '孟加拉语(বাংলা)', value: 'ben' },
  { label: '哈萨克语(Қазақ тілі)', value: 'kz' },
  { label: '韩语(한국어)', value: 'kor' },
  { label: '缅甸语(မြန်မာဘာသာ)', value: 'bur' },
  { label: '土耳其语(Türkçe)', value: 'tr' },
  { label: '柬埔寨语(ភាសាខ្មែរ)', value: 'km' },
  { label: '西班牙语(Español)', value: 'es' },
  { label: '阿拉伯语(العربية)', value: 'ar' },
]
const templateImportUrlPrefixList = [
  'http://eggrj.oss-cn-hangzhou.aliyuncs.com/bluenCustomTag/',
  'https://eggrj.oss-cn-hangzhou.aliyuncs.com/bluenCustomTag/',
]
const templateImportRequest = createAxiosWithGlobal({
  timeout: 20000,
})
export default {
  name: 'printTag',
  data() {
    return {
      data: [],
      template_list: [],
      active_template_id: -1,
      operate_template_id: -1,
      canvas_scale: 2,
      cur_template: null,
      showImportTemplateModal: false,
      importTemplateUrl: '',
      importTemplateError: '',
      importTemplateLoading: false,
      need_lave: false, // 生成余料标签
      need_lave_surplus: false, // 生成余料大板下的余料标签
      cut_need_lave: true, // 生成裁剪余料标签
      cut_need_lave_surplus: true, // 生成余料大板下的裁剪余料标签
      gen_big_plank_tag: false, // 生成大板信息标签
      gen_big_plank_surplus_tag: false, // 生成余料大板标签
      gen_small_plank_tag: true, // 生成小板标签
      gen_small_plank_tag_surplus: true, // 生成余料大板下的小板标签
      gen_no_cut_tag: false, // 生成不下料板件标签
      is_lave_tag_end: true, // 裁剪余料标签生成在末尾
      is_lave_tag_end_sur: true, // 余料大板裁剪余料标签生成在末尾
      isGenNcSuffix: true, // 大板标签生成下料文件名后缀
      jx_checked: false, // 标签图镜像
      five_six_dir: false, // 五六面钻放板基准
      // 是否在标签中设置了自定义放板基准
      isCustomSixSideDrillPlankBase: false,
      sort_value: 1, // 标签排序适应自动上下料
      print_color_tag: false, //生成彩色标签
      gen_part_color_revert: false, // 生成小板反色标签
      roomCabinetPanelNameDisplay: false, // 是否显示房间柜体面板名称
      dualLanguageTags: [], // 双语标签用户设置此字段需要翻译
      xCoordinate: 32, // x坐标
      yCoordinate: 20, // y坐标
      saveConfBtnLoading: false,
      file_setting: [],
      file_setting_extra: { img_has_delimiter: false, stock_num_length: 3 },
      file_setting_delimiter: '',
      isVisible: false,
      // all_page: 0,collect
      source_data: [],
      default_sort_source_data: [],
      tag_svg_list: [],
      lave_data: [],
      lave_svg_list: [],
      template_loading: true,
      export_loading: false,
      export_loading_text: translate('printPage.prepareData'),
      // 设置print_setting初始值
      print_setting: {
        cols: 1,
        labelColumnGap: 0,
        opacity: 0.24,
        size: 1,
        sizeAuto: true, //默认勾选特殊标记大小自适应
      },

      showLoading: false,
      timer: (ms) => new Promise((resolve) => setTimeout(resolve, ms)),
      collect: [], // 图片信息收集器
      lave_collect: [],
      // 上一次排版的数据
      afterPaibanData: [],
      // 是否是排版数据变化
      isPaibanDataChange: false,
      testList: [],
      isNoMoreTag: false,
      isTagLoading: false,
      page: 1, // 第几页
      lavePage: 1, // 余料第几页
      limit: 5, // 每页的额个数
      // canvasUrl: '',
      tagListSourceData: [], // 用来生成标签canvas的数据
      laveTagListSourceData: [], // 预料标签生成canvas的数据
      // renderTag: null, // 生成渲染内容的函数
      listDomWrap: null,
      useOld: true,
      useLoadMore: false,
      time: 0,
      isSameTypeSet: false,
      isLoadLavePart: false, // 如果是直接加载全部，有没有这个都无所谓，暂时先保留
      cacheTagList: {}, // 缓存当前的标签
      pdfPageCount: 0, // pdf的页面count，用于导出时的页面loading百分比
      exportType: 'image', // 区分导出的类型，不用的类型百分比的取值来源不同
      isInCurrentRoute: false, // 是否在当前路由，主要为了解决离开当前页面以后，依旧加载的问题
      /** 执行 id,用于判断 loadingtaglist 是否在执行一个新的函数 */
      executeId: '',
      nc_file_settings: {}, // nc文件设置
      ncNameSuffix: 'nc', // nc文件名后缀
      // fileSetting_header_ids: {}, //文件设置的ids
      // needAddNcNamePrefix: false // 是否需要添加nc名前缀
      select_options: [], // 筛选数据
      cut_select_value: 'all',
      cut_progress: 0, //当前进度
      isPrintTagMark: false, // 是否给打印标签加上标记
      inQt: false,
      currentBigpart: null,
      isreloading: false, //是否在重新加载
      isCanDownLoading: false, // 是否可以下载文件
      isShowToolTip: false,
      ncOutputSetting: {}, // NC导出设置
      paibanWayName: `历史方案 ${splitTime()}`,
      ncFileList: [], //nc文件名
      bigplantLableList: {},
      LaveTagBase64List: {},
      isTimeOut: false,
      roomSortWay: '', //板件标记房间排序规则
      isShowFolderTip: false,
      isPrintFlag: false, //是否点击打印
      // 生成彩色标签提示信息遍历数据
      colorTagTips: [
        {
          title: 'common.order',
          imgUrl: order,
          id: 1,
        },
        {
          title: 'common.room',
          imgUrl: room,
          id: 2,
        },
        {
          title: 'common.modular',
          imgUrl: modular,
          id: 3,
        },
        {
          title: 'common.isDoorPlank',
          imgUrl: door,
          id: 4,
        },
      ],
      activeTagKey: 'normal',
      /** 是否在加载字体 */
      isLoadFont: false,
      /** 是否在等待加载 */
      isLoadWaitting: false,
      /** 是否发送至彩标*/
      isSendToEzSort: false,
      /** 标签上的导出语言 */
      exportLanguage: '',
      exportLanguageOptions,
      isBatchTagging: false,
      tagList: [],
      tagSize: {
        width: 0,
        height: 0,
      },
      pdfSrc: '',
      // 用于新版规则的进度记载
      loadTimer: null,
    }
  },
  methods: {
    ...mapMutations([
      'setDrawOpacity',
      'setDrawSize',
      'setDrawSizeAuto',
      'setTempList',
    ]),
    handleChangeNewLoad() {
      this.cut_progress = 0
      this.isTagLoading = false

      this.saveConf()
    },
    translateLang(key) {
      return translate(key)
    },
    // tooltip鼠标显示
    showTooltip(e) {
      this.isShowToolTip = true
    },
    hideTooltip(e) {
      this.isShowToolTip = false
    },
    // 保存设置
    async saveConf() {
      updateLocalPreference({
        labelTemplate: this.active_template_id,
        surplusLabel: this.need_lave,
        surplusLabelForSur: this.need_lave_surplus,
        bigPlankLabel: this.gen_big_plank_tag,
        bigPlankLabelForSur: this.gen_big_plank_surplus_tag,
        genSmallPlankLabel: this.gen_small_plank_tag,
        genSmallPlankLoaelForSurplus: this.gen_small_plank_tag_surplus,
        genNoCutTag: this.gen_no_cut_tag,
        isGenNcSuffix: this.isGenNcSuffix,
        mirrorLabel: this.jx_checked,
        boardBenchmark: this.five_six_dir,
        labelSortWay: this.sort_value,
        printColorTag: this.print_color_tag,
        genPartColorRevert: this.gen_part_color_revert,
        roomCabinetPanelNameDisplay: this.roomCabinetPanelNameDisplay,
        dualLanguageTags: this.dualLanguageTags,
        labelColumnNum: this.print_setting.cols,
        labelColumnGap: this.print_setting.labelColumnGap,
        opacity: this.print_setting.opacity,
        size: this.print_setting.size,
        sizeAuto: this.print_setting.sizeAuto,
        cutNeedLave: this.cut_need_lave,
        cutNeedLaveForSur: this.cut_need_lave_surplus,
        cutLaveEnd: this.is_lave_tag_end,
        cutLaveEndForSur: this.is_lave_tag_end_sur,
        labelCoord: {
          X: this.xCoordinate,
          Y: this.yCoordinate,
        },
        isSendToEzSort: this.isSendToEzSort,
      })
      this.setDrawOpacity(this.print_setting.opacity)
      this.setDrawSize(this.print_setting.size)
      this.setDrawSizeAuto(this.print_setting.sizeAuto)
    },
    async loadLave() {
      this.isNoMoreTag = false
      this.isLoadLavePart = true
      if (this.useLoadMore) {
        this.judgeLoadContinue()
      } else {
        // this.loadTagList(false, true)
        await this.waitGenAll()
      }
    },
    /** 生成余料标签 **/
    changeNeedLave() {
      this.$htm_trackEvent('生成余料标签', 'click', this.need_lave)
      this.cut_progress = 0
      this.isTagLoading = false
      this.isSameTypeSet = false
      this.initLaveData()
      // if (this.need_lave && !this.lave_svg_list.length)  this.startRenderLave()
      this.startRender()
      if (!this.isNewTagDraw) {
        if (this.need_lave || this.need_lave_surplus) {
          if (this.lave_svg_list.length) {
            const tagArr = [...this.tag_svg_list]
            if (this.is_lave_tag_end || this.is_lave_tag_end_sur) {
              this.lave_svg_list.forEach((tag) => {
                const startIndex = tagArr.findIndex(
                  (item) => item.plank_index == tag.plank_index
                )
                if (startIndex !== -1) {
                  const insertIndex =
                    startIndex +
                    tagArr.filter((item) => item.plank_index == tag.plank_index)
                      .length
                  tagArr.splice(insertIndex, 0, tag)
                }
              })
              this.tag_svg_list = tagArr
            } else {
              this.tag_svg_list = [...this.tag_svg_list, ...this.lave_svg_list]
            }
            if (this.tag_svg_list.length < this.renderDataList.length) {
              this.loadLave()
            } else {
              this.loadLave()
            }
          } else {
            if (this.isNoMoreTag && this.laveTagListSourceData.length) {
              this.loadLave()
            }
          }
          if (this.need_lave) {
            buryPointApi('tag', 'gen_surplus_tag')
          }
          if (this.need_lave_surplus) {
            buryPointApi('tag', 'gen_surplus_tag_surplus')
          }
        } else {
          if (this.lave_svg_list.length) {
            this.tag_svg_list = this.tag_svg_list.filter(
              (item) => item.type !== 'laveTag'
            )
            this.isNoMoreTag = true
          }
        }
      }

      this.saveConf()
    },
    /**  */
    changeCutLaveEnd() {
      // this.$htm_trackEvent('生成余料标签', 'click', this.need_lave)
      this.cut_progress = 0
      this.isTagLoading = false
      this.startRender()
      this.saveConf()
    },

    /** 筛选改变 */
    siftChange() {
      buryPointApi('tag', 'screen')
      this.cut_progress = 0
      this.tagListSourceData = []
      this.initData()
      this.initLaveData()
      this.startRender()
    },
    /** 生成裁剪板件标签 */
    changeCutNeedLave() {
      this.cut_progress = 0
      this.startRender()
      this.saveConf()
      this.isSameTypeSet = false
      if (this.cut_need_lave) {
        buryPointApi('tag', 'gen_cut_tag')
      }
      if (this.cut_need_lave_surplus) {
        buryPointApi('tag', 'gen_cut_tag_surplus')
      }
    },
    /** 生成大板标签 */
    changeGenBigPlankTag() {
      this.$htm_trackEvent('生成大板标签', 'click', this.gen_big_plank_tag)
      this.cut_progress = 0
      // 为了避免 loadTagList 里面时间戳判断滞后导致的无法加载的问题
      this.isTagLoading = false
      this.isSameTypeSet = false
      this.startRender()
      this.saveConf()
      if (this.gen_big_plank_tag) {
        buryPointApi('tag', 'gen_bigPlank_tag')
      }
      if (this.gen_big_plank_surplus_tag) {
        buryPointApi('tag', 'gen_big_plank_surplus_tag')
      }
    },
    /**生成小板标签 */
    changeGenSmallPlankTag() {
      this.$htm_trackEvent('生成小板标签', 'click', this.gen_small_plank_tag)
      this.cut_progress = 0
      this.isTagLoading = false
      this.isSameTypeSet = false
      this.startRender()
      this.saveConf()
      if (this.gen_small_plank_tag) {
        buryPointApi('tag', 'gen_small_plank_tag')
      }
      if (this.gen_small_plank_tag_surplus) {
        buryPointApi('tag', 'gen_small_plank_tag_surplus')
      }
    },
    handleXChange() {
      this.saveConf()
    },
    handleYChange() {
      this.saveConf()
    },
    // 标签全选
    handleAll() {
      // 同时处理标准大板和余料大板的全选状态
      const isChecked = !(this.checkAllForNor && this.checkAllForSur)

      // 更新标准大板标签状态
      this.gen_small_plank_tag = isChecked
      this.cut_need_lave = isChecked
      this.need_lave = isChecked
      this.gen_big_plank_tag = isChecked
      this.gen_no_cut_tag = isChecked

      // 更新余料大板标签状态
      this.gen_small_plank_tag_surplus = isChecked
      this.cut_need_lave_surplus = isChecked
      this.need_lave_surplus = isChecked
      this.gen_big_plank_surplus_tag = isChecked
      this.changeAllTagNext()
    },
    // 标准大版标签全选
    handleAllForNormal() {
      const isChecked = !this.checkAllForNor
      this.gen_small_plank_tag = isChecked
      this.cut_need_lave = isChecked
      this.need_lave = isChecked
      this.gen_big_plank_tag = isChecked

      this.changeAllTagNext()
    },
    // 余料大板标签全选
    handleAllForSurplus() {
      const isChecked = !this.checkAllForSur
      this.gen_small_plank_tag_surplus = isChecked
      this.cut_need_lave_surplus = isChecked
      this.need_lave_surplus = isChecked
      this.gen_big_plank_surplus_tag = isChecked

      this.changeAllTagNext()
    },
    changeAllTagNext() {
      this.cut_progress = 0
      this.isTagLoading = false
      this.isSameTypeSet = false
      this.initLaveData()
      this.startRender()
      if (!this.isNewTagDraw) {
        if (this.need_lave || this.need_lave_surplus) {
          if (this.lave_svg_list.length) {
            const tagArr = [...this.tag_svg_list]
            if (this.is_lave_tag_end || this.is_lave_tag_end_sur) {
              this.lave_svg_list.forEach((tag) => {
                const startIndex = tagArr.findIndex(
                  (item) => item.plank_index == tag.plank_index
                )
                if (startIndex !== -1) {
                  const insertIndex =
                    startIndex +
                    tagArr.filter((item) => item.plank_index == tag.plank_index)
                      .length
                  tagArr.splice(insertIndex, 0, tag)
                }
              })
              this.tag_svg_list = tagArr
            } else {
              this.tag_svg_list = [...this.tag_svg_list, ...this.lave_svg_list]
            }
          } else {
            if (this.isNoMoreTag && this.laveTagListSourceData.length) {
              this.loadLave()
            }
          }
        } else {
          if (this.lave_svg_list.length) {
            this.tag_svg_list = this.tag_svg_list.filter(
              (item) => item.type !== 'laveTag'
            )
            this.isNoMoreTag = true
          }
        }
      }
      this.saveConf()
    },
    // 生成不下料板件标签
    handleChangeNoCutTag() {
      this.cut_progress = 0
      this.isTagLoading = false
      this.isSameTypeSet = false
      this.startRender()
      this.saveConf()
      if (this.gen_no_cut_tag) {
        buryPointApi('tag', 'gen_no_cut_tag')
      }
    },
    /** 大板标签生成下料文件名后缀 */
    handleChangeNCSuffix() {
      this.cut_progress = 0
      this.startRender()
      this.saveConf()
      if (this.isGenNcSuffix) {
        buryPointApi('tag', 'gen_nc_suffix')
      }
    },

    /** 标签图镜像 **/
    changeJxChecked() {
      this.$htm_trackEvent('标签图镜像', 'click', this.jx_checked)
      this.cut_progress = 0
      if (!this.isNewTagDraw) {
        this.source_data = JxTagData(this.source_data)
        this.lave_data = JxTagData(this.lave_data)
        this.default_sort_source_data = JxTagData(this.default_sort_source_data)
      }
      this.isSameTypeSet = false
      this.startRender()
      this.saveConf()
      if (this.jx_checked) {
        buryPointApi('tag', 'jx_checked')
      }
    },
    /** 五六面钻放板基准 */
    changeFiveSixDir() {
      this.cut_progress = 0
      this.startRender()
      this.saveConf()
      if (this.five_six_dir) {
        buryPointApi('tag', 'five_six_dir')
      }
    },
    /** 标签排序适应自动上下料 **/
    changeSortValue() {
      this.$htm_trackEvent(
        '标签适应上下料',
        'click',
        this.sort_value === 2 ? '向上' : this.sort_value === 3 ? '向下' : '默认'
      )
      this.cut_progress = 0
      this.isSameTypeSet = false
      this.startRender()
      this.saveConf()
    },
    // 重置上下料数据
    resetUpDownMaterialData() {
      // 是否是默认或者source_data没有数据(source_data没有数据应该是代码执行时序引起的)
      const isUseDefault = this.sort_value === 1 || !this.source_data.length
      this.source_data = isUseDefault
        ? this.default_sort_source_data
        : countTagDataByDir(
            this.sort_value,
            this.source_data,
            this.$store.state.ncSetting.xyReverse
          ).tagItemArr
    },
    /** 生成彩色标签 */
    handleChangeColorTag() {
      // 埋点记录
      if (this.print_color_tag) {
        buryPoint({
          function_module: 'tag',
          function_point: 'form_color_label',
        })
      }
      this.cut_progress = 0
      // 重新绘制
      this.startRender()
      this.saveConf()
    },
    // 生成小板标签反色
    handleChangeColorRevert() {
      if (this.gen_part_color_revert) {
        buryPointApi('tag', 'gen_part_color_revert')
      }
      this.cut_progress = 0
      // 重新绘制
      this.startRender()
      this.saveConf()
    },
    // 是否显示双语
    handleChangeDispaly() {
      this.cut_progress = 0
      // 重新绘制
      this.startRender()
      this.saveConf()
    },
    /** @description 开启双语标签 */
    async handleChangeDualLanguageTags(val) {
      if (val?.target?.checked) {
        // 权限验证以及提示
        await this.checkIsExport()
      }
      buryPoint({ function_module: 'tag', function_point: 'bilingualTag' })

      this.handleChangeDispaly()
    },
    /** 获取模板列表 **/
    getTemplateList() {
      return this.$getByToken(
        '/get_tag_setting_list',
        { limit: 100, page: 1 },
        async (res) => {
          if (res.status == 1 && res.data && res.data instanceof Array) {
            this.template_list = [
              { id: 0, name: '默认模板（60×40）' },
              ...res.data,
            ]
            const tagTempList = [
              { id: 0, name: '默认标签模板', data: defaultTagData },
              ...res.data,
            ]
            this.setTempList(tagTempList)
            // 选取默认使用模板
            // let active_template_id = Number(
            //   localStorage.getItem('testNowTagId')
            // )
            // if (!active_template_id && active_template_id !== 0)
            //   active_template_id = Number(
            //     this.$store.state.userInfo.custom_tag_id
            //   )
            // 现在直接使用接口里面的id就行了
            let match_templates = this.template_list.find(
              (template) => template.is_default === 1
            )
            const prolineId = this.$store.state.ncSetting.process_setting_id
            const tempId = this.$store.state.ncSetting.tag_template_id
            if (prolineId && tempId !== -1) {
              const selectTemp = this.template_list.find(
                (template) => template.id === tempId
              )
              if (selectTemp) {
                match_templates = selectTemp
              }
            }
            if (match_templates) await this.chooseTemplate(match_templates)
            else await this.chooseTemplate(this.template_list[0])
          } else {
            this.template_list = [{ id: 0, name: '默认模板（60×40）' }]
            await this.chooseTemplate(this.template_list[0])
          }

          this.template_loading = false
          this.isreloading = false
        }
      )
    },
    /** 编辑模板 **/
    editTemplate(template) {
      const targetTemplate =
        template ||
        this.template_list.find((item) => item.id === this.active_template_id)
      buryPointApi('tag', 'editor_tag')
      if (!targetTemplate?.id) {
        this.$message({ message: '默认标签不可编辑' })
        return
      }
      this.$htm_trackEvent('编辑标签模板', 'click')
      // 标签管理页面进入的添加模板参数，用于活跃菜单的判断
      let from = this.$route.query.from === 'temp' ? 'temp' : undefined

      // 关闭删除模板弹窗
      this.isVisible = false
      this.$router.push({
        path: '/editTagTem',
        query: {
          id: targetTemplate.id,
          from,
        },
      })
    },
    /** 添加模板 **/
    addTemplate() {
      this.$htm_trackEvent('添加标签模板', 'click')
      buryPointApi('tag', 'add')
      this.$router.push({ path: '/editTagTem' })
    },
    openTemplateImportModal() {
      this.showImportTemplateModal = true
      this.importTemplateUrl = ''
      this.importTemplateError = ''
    },
    resetImportTemplateState() {
      this.showImportTemplateModal = false
      this.importTemplateUrl = ''
      this.importTemplateError = ''
      this.importTemplateLoading = false
    },
    /** 删除模板 **/
    deleteTemplate(template) {
      const targetTemplate =
        template ||
        this.template_list.find((item) => item.id === this.active_template_id)
      this.operate_template_id = targetTemplate?.id ?? -1
      buryPointApi('tag', 'delete')
      if (!targetTemplate?.id) {
        this.operate_template_id = -1
        this.$message({
          duration: 1000,
          message: this.$translateLang('默认模板不能删除'),
          type: 'warning',
        })
        return
      }
      this.isVisible = true
    },
    // 删除模板ftypeName
    handleDelateTemplate() {
      const templateId =
        this.operate_template_id > -1
          ? this.operate_template_id
          : this.active_template_id
      this.$token('/delete_tag_setting', { id: templateId }, (res) => {
        if (res.status != 1) return
        this.$message({
          duration: 1000,
          message: translate('common.deleteSuccess'),
          type: 'success',
        })
        this.getTemplateList()
      }).finally(() => {
        this.isVisible = false
        this.operate_template_id = -1
      })
    },
    getTemplateImportName() {
      const date = new Date()
      const hour = ('0' + date.getHours()).slice(-2)
      const minute = ('0' + date.getMinutes()).slice(-2)
      const second = ('0' + date.getSeconds()).slice(-2)
      return `导入模板${hour}${minute}${second}`
    },
    validateTemplateImportUrl(rawUrl) {
      const urlText = String(rawUrl || '').trim()
      if (!urlText) return null
      try {
        const url = new URL(urlText)
        const href = url.href
        const isValidPrefix = templateImportUrlPrefixList.some((prefix) =>
          href.startsWith(prefix)
        )
        if (
          !isValidPrefix ||
          !/\.json($|\?)/i.test(url.pathname + url.search)
        ) {
          return null
        }
        return href
      } catch (error) {
        return null
      }
    },
    normalizeImportedTemplateData(templateData) {
      if (!templateData || typeof templateData !== 'object') return null
      const defaultTemplateData = JSON.parse(defaultTagData)
      const {
        rectInfo,
        surplus_data: rawSurplusData,
        surplus_tem_data: rawSurplusTemData,
        surplus_waste_data: rawSurplusWasteData,
        tag_height: rawTagHeight,
        tag_width: rawTagWidth,
        tem_data: rawTemData,
        enable_sub: rawEnableSub,
        sub_tem_data: rawSubTemData,
      } = templateData
      const temData = Array.isArray(rawTemData) ? rawTemData : null
      const nextSurplusData = Array.isArray(rawSurplusData)
        ? rawSurplusData
        : rawSurplusTemData
      const surplusData = Array.isArray(nextSurplusData)
        ? nextSurplusData
        : defaultTemplateData.surplus_tem_data
      const surplusWasteData = Array.isArray(rawSurplusWasteData)
        ? rawSurplusWasteData
        : surplusData
      const tagWidth = Number(rawTagWidth)
      const tagHeight = Number(rawTagHeight)
      const rectLeft = Number(rectInfo?.left)
      const rectTop = Number(rectInfo?.top)
      const enableSub = rawEnableSub === true
      const subTemData = Array.isArray(rawSubTemData) ? rawSubTemData : null
      if (
        !temData ||
        !Array.isArray(surplusData) ||
        !Array.isArray(surplusWasteData) ||
        !Number.isFinite(tagWidth) ||
        !Number.isFinite(tagHeight) ||
        !Number.isFinite(rectLeft) ||
        !Number.isFinite(rectTop) ||
        !Array.isArray(subTemData)
      ) {
        return null
      }
      return {
        tem_data: temData,
        tag_width: tagWidth,
        tag_height: tagHeight,
        rectInfo: {
          left: rectLeft,
          top: rectTop,
        },
        surplus_data: surplusData,
        surplus_waste_data: surplusWasteData,
        enable_sub: enableSub,
        sub_tem_data: subTemData,
      }
    },
    sanitizeImportedTemplateItem(item, permissions, disabledFeatureSet) {
      const nextItem = cloneDeep(item)
      if (!permissions.hasOpacityAuth) {
        if (nextItem?.data && typeof nextItem.data === 'object') {
          if (
            (nextItem.type === 'FixedText' || nextItem.type === 'DataSource') &&
            'opacity' in nextItem.data &&
            nextItem.data.opacity !== 1
          ) {
            nextItem.data.opacity = 1
            disabledFeatureSet.add('透明度')
          }
        }
      }
      return nextItem
    },
    sanitizeImportedTemplateDataByPermission(templateData, permissions) {
      const disabledFeatureSet = new Set()
      const sanitizeList = (list = []) =>
        list.map((item) =>
          this.sanitizeImportedTemplateItem(
            item,
            permissions,
            disabledFeatureSet
          )
        )
      return {
        data: {
          ...templateData,
          tem_data: sanitizeList(templateData.tem_data),
          surplus_data: sanitizeList(templateData.surplus_data),
          surplus_waste_data: sanitizeList(templateData.surplus_waste_data),
          sub_tem_data: sanitizeList(templateData.sub_tem_data),
        },
        missingFeatures: Array.from(disabledFeatureSet),
      }
    },
    async getTemplateImportPermissions() {
      const permissions = {
        hasOpacityAuth: true,
      }
      try {
        const opacityRes = await fetchUserPermission({
          permission_type: 'TAG_OPACITY',
        })
        if (opacityRes.status) {
          permissions.hasOpacityAuth = opacityRes.data.enable
        }
      } catch (error) {
        permissions.hasOpacityAuth = true
      }
      return permissions
    },
    async copyTemplateRenderUrl(template) {
      const renderUrl = template?.render_url
      if (!renderUrl) {
        this.$message.warning(this.$translateLang('当前模板暂无可复制链接'))
        return
      }
      copyText(
        renderUrl,
        this.$translateLang('已复制当前模板数据链接。'),
        this.$translateLang('复制模板链接失败，请稍后重试')
      )
    },
    async handleImportTemplate() {
      const importUrl = this.validateTemplateImportUrl(this.importTemplateUrl)
      if (!importUrl) {
        this.importTemplateError = this.$translateLang(
          '无法识别导入模板链接，请重新下载后导入'
        )
        return
      }
      this.importTemplateLoading = true
      this.importTemplateError = ''
      try {
        const response = await templateImportRequest.get(
          importUrl.replace(/^http:/, 'https:')
        )
        const remoteData = ensureTagDataDefaults(
          typeof response.data === 'string'
            ? JSON.parse(response.data)
            : response.data
        )
        const templateData = this.normalizeImportedTemplateData(remoteData)
        if (!templateData) {
          throw new Error('INVALID_TEMPLATE_DATA')
        }
        const permissions = await this.getTemplateImportPermissions()
        const { data: sanitizedTemplateData, missingFeatures } =
          this.sanitizeImportedTemplateDataByPermission(
            templateData,
            permissions
          )
        const importDraftKey = `print_tag_import_${Date.now()}`
        sessionStorage.setItem(
          importDraftKey,
          JSON.stringify({
            type: 'importTemplateDraft',
            name: this.getTemplateImportName(),
            data: sanitizedTemplateData,
            permissions,
            missingFeatures,
          })
        )
        this.resetImportTemplateState()
        this.$router.push({
          path: '/editTagTem',
          query: {
            importDraftKey,
            from: this.$route.query.from === 'temp' ? 'temp' : undefined,
          },
        })

        // 添加数据埋点
        buryPointApi('tag', 'importTemplate')
      } catch (error) {
        this.importTemplateError = '无法识别导入模板链接，请重新下载后导入。'
      } finally {
        if (this.showImportTemplateModal) {
          this.importTemplateLoading = false
        }
      }
    },
    /** 选中模板 **/
    async chooseTemplate(template, isClick) {
      const { process_setting_id } = this.$store.state.ncSetting
      // 需要真实存在的生产线 id
      const proLineId = process_setting_id > 0 ? process_setting_id : undefined
      localStorage.setItem('testNowTagId', template.id)
      if (template.id === this.active_template_id && !this.isPaibanDataChange)
        return
      this.cut_progress = 0
      this.time = Date.now()
      this.isPaibanDataChange = false
      this.active_template_id = template.id
      // 获取模板详情
      if (!this.active_template_id) {
        const payloadObj = proLineId
          ? { id: 0, default: 1, process_line_id: proLineId }
          : { id: 0, default: 1 }
        // 默认模板（40x60）
        this.cur_template = ensureTagDataDefaults(JSON.parse(defaultTagData))
        this.isCustomSixSideDrillPlankBase = false
        this.$getByToken('/load_tag_setting', payloadObj, (res) => [])
        buryPointApi('tag', 'use_default_template')
      } else {
        buryPointApi('tag', 'use_customize_template')
        let self = this
        let getInfo = function (id) {
          const payloadObj = proLineId
            ? { id, default: 1, process_line_id: proLineId }
            : { id, default: 1 }
          return self.$getByToken('/load_tag_setting', payloadObj, (res) => {
            // 遍历res.data.data.tem_data，如果存在type为sixSideDrillPlankBase的item，则设置isCustomSixSideDrillPlankBase为true
            self.isCustomSixSideDrillPlankBase = res.data.data.tem_data.some(
              (item) =>
                item.type === 'sixSideDrillArrow' ||
                item.type === 'sixSideDrillTriangle'
            )
            self.cur_template = ensureTagDataDefaults(res.data.data)
            self.cur_template?.tem_data.forEach((item) => {
              if (item.data && item.data.source_data == 'oSize') {
                item.data = { ...item.data, text: '2440X1220X18' }
              }
              if (item.data && item.data.source_data == 'plankSize') {
                item.data = { ...item.data, text: '2440*1220*18' }
              }
              if (item.type === 'Typography') {
                // 将字体大小数据存进store
                self.$store.commit('setfrontLabelFont', {
                  fontSize: item.data?.textItems[0]?.fontSize,
                  fontPt: item.data?.textItems[0]?.fontPt,
                  fontFamily: item.data?.textItems[0]?.fontFamily,
                  fontWeight: item.data?.textItems[0]?.fontWeight,
                })
              }
              // 选择了柜体排序（按房间排序的话），此处存储上房间序号的规则
              if (item.type === 'wardrobeNum') {
                self.roomSortWay = item.data.roomSortWay
              }
              if (item.type === 'VisibleEdge') {
                // 如果选中的模板包含见光边绘制
                buryPointApi('tag', 'plank_VisibleEdge')
              }
            })
            const barCode = self.cur_template.tem_data.find(
              (it) => it.type === 'Onecode' && it.data.code_type === 'EAN13'
            )
            self.isreloading = false
            if (barCode && self.ncSetting.genSimpleLabelBarcode) {
              const cb = self.editTemplate.bind(self)
              modalMsg(
                translate('printPage.simplifyOneCodeTip'),
                'warning',
                translate('common.warning'),
                cb,
                {
                  okText: translate('printPage.toEdit'),
                  maskClosable: true,
                  closable: true,
                }
              )
            }
          })
        }
        await getInfo(template.id)
      }
      this.$store.commit('setCurTemplate', this.cur_template)
      if (isClick) {
        updateLocalPreference({
          isChangeTagTemp: true,
        })
      }
      // 重置 tag_svg_list ，防止页面跳动
      this.tag_svg_list = []
      // 副标签是否生成依赖当前模板，切换模板时需要重建列表
      this.isSameTypeSet = false
      // return
      if (!proLineId) {
        this.startRender()
        return
      }
      this.$token(
        '/load_engraving_setting',
        { setting_id: proLineId },
        (res) => {
          this.isreloading = false
          this.ncNameSuffix =
            res.data.ncOutputSetting.fileType.fileNameType.toLowerCase()
          this.ncOutputSetting = res.data.ncOutputSetting
          this.startRender()
        }
      )

      this.$nextTick(() => {
        const templateIndex = this.template_list.findIndex(
          (item) => item.id === template.id
        )
        this.$refs['tagTempListRef'].scrollTo({
          top: templateIndex * 34 < 0 ? 0 : templateIndex * 34,
          behavior: 'smooth',
        })
      })
    },
    /** 获取nc设置 **/
    getFileSetting() {
      let params = {
        process_setting_id:
          this.$store.state.ncSetting.process_setting_id || -1,
        uid: this.$store.state.userInfo.id,
      }
      return this.$token('/get_nc_file_settings', params, (res) => {
        if (res.status != 1) return

        let label_dict = res.data.label_dict
        let nc_file_settings = res.data.nc_file_settings
        this.nc_file_settings = nc_file_settings
        let header_ids = nc_file_settings.customizeSetting.headerIds
        // 如果true，则使用_,这是为了兼容旧数据
        this.file_setting_delimiter =
          nc_file_settings.hasDelimiter === true
            ? '_'
            : nc_file_settings.hasDelimiter
        this.file_setting_extra = {
          stock_num_length: nc_file_settings.stockNumLength,
        }
        let ids = []
        let template_string = nc_file_settings.customizeSetting.templateString
        if (template_string) {
          if (nc_file_settings.hasDelimiter) {
            const spit = nc_file_settings.hasDelimiter
            template_string = template_string.split(spit).map((item) => {
              return item.match(/\{([^)]*)\}/)[1]
            })
          } else {
            template_string = template_string.slice(1, -1)
            template_string = template_string.split('}{')
          }
        } else template_string = []

        template_string.forEach((item) => {
          ids.push(header_ids[item])
        })
        this.file_setting = []
        ids.forEach((id) => {
          let item = label_dict[String(id)]
          let label = '',
            value = ''
          if (item.label_name == 'direction') {
            label = 'front'
            value = nc_file_settings.front_info ?? nc_file_settings.front
          } else if (item.label_name == 'labelMachineName') {
            label = 'labelMachineName'
            value = nc_file_settings.labelMachineName
          } else if (item.label_name == 'machineCenterName') {
            label = 'labelMachineName'
            value = nc_file_settings.machineCenterName
          } else {
            label = item.label_name
          }
          this.file_setting.push({ label, value })
        })
      })
    },
    showPartSize(part, field, needShowField) {
      const rect = getOriginRect(part, field)
      return (rect?.[needShowField] ?? 0).toFixed(2)
    },
    /** 预处理数据 **/
    initData() {
      const paibanData = JSON.parse(
        JSON.stringify(this.$store.state.paibanData)
      )
      // 有批量补标签数据时 将相应paibanData小板标记为批量补标签
      if (this.batchTaggingList.length) {
        this.isBatchTagging = true
        let batchTaggingIds = this.batchTaggingList.map(
          (item) => item.partUniqueId
        )
        paibanData.forEach((item) => {
          item.parts.forEach((part) => {
            if (batchTaggingIds.includes(part.partUniqueId)) {
              part.isBatchTagging = true
            }
          })
        })
      }
      let onePart = null
      if (this.currentBigpart) {
        onePart = this.currentBigpart
      }
      let data = this.currentBigpart ? [onePart] : paibanData
      data = this.selectViewData(data)
      // 生成标签id
      // this.generateLabelNo(data)
      if (!data.length) {
        data = defaultPaibanData
      }
      if (this.$route.query.from === 'temp') {
        data = defaultPaibanData
      }
      // 正反面条码填充值
      let front_file_identifier =
        this.$store.state.ncSetting.front_file_identifier
      let opposite_file_identifier =
        this.$store.state.ncSetting.opposite_file_identifier
      // let len = 0,
      // let parts_index = 1
      // 记录有几个柜子
      let wardrobe_names = {},
        record_wardrobe_num = 0
      data.forEach((item, index) => {
        // 添加可筛选数据
        // item.parts = item.parts.filter(v =>{ return  v.specialType !== 'supplus'; });
        // len += item.parts.length

        item.parts.forEach((part) => {
          if (
            (!part.specialType ||
              (part.specialType && part.specialType !== 'supplus')) &&
            !part.surplusPath
          ) {
            part.oriPlankNumF = `${part.plankNum}${opposite_file_identifier}`
            if (front_file_identifier) {
              if (this.isNewTagDraw) {
                const pn = String(part.plankNum)
                part.plankNum = `${pn}${front_file_identifier}`
              } else {
                part.plankNum = `${part.plankNum}${front_file_identifier}`
              }
              part.oriPlankNum = part.plankNum
            }
          }

          let label_img_name = ''
          if (this.$store.state.ncSetting.labelFormat === 'jingmei') {
            label_img_name += `${item.parts[0].address}_`
            this.file_setting.forEach((set) => {
              if (
                set.label === 'front' ||
                set.label === 'labelMachineName' ||
                set.label === 'machineCenterName'
              ) {
                if (set.value) {
                  if (this.file_setting_delimiter)
                    label_img_name += `${set.value}_`
                  else label_img_name += `${set.value}`
                }
              } else {
                if (this.file_setting_delimiter) {
                  if (set.label === 'stockNum') {
                    if (
                      String(index + 1).length <
                      this.file_setting_extra.stock_num_length
                    )
                      label_img_name += `${prefixInteger(
                        index + 1,
                        this.file_setting_extra.stock_num_length
                      )}_`
                    else label_img_name += `${index + 1}_`
                  } else label_img_name += `${part[set.label]}_`
                } else {
                  if (set.label === 'stockNum') {
                    if (
                      String(index + 1).length <
                      this.file_setting_extra.stock_num_length
                    )
                      label_img_name += `${prefixInteger(
                        index + 1,
                        this.file_setting_extra.stock_num_length
                      )}`
                    else label_img_name += `${index + 1}`
                  } else label_img_name += `${part[set.lable]}`
                }
              }
            })
          }
          part.lableImgName =
            label_img_name +
            (this.ncSetting.genSimpleLabelBarcode
              ? part.simplePlankNum
              : part.oriPlankNum)

          // part.partsIndex = parts_index
          // parts_index++

          if (wardrobe_names.hasOwnProperty(`${part.loc}_${part.roomID}`))
            part.wardrobeNum = wardrobe_names[`${part.loc}_${part.roomID}`]
          else {
            record_wardrobe_num++
            wardrobe_names[`${part.loc}_${part.roomID}`] = record_wardrobe_num
            part.wardrobeNum = wardrobe_names[`${part.loc}_${part.roomID}`]
          }
          // 合并骨骼门标签数据按基板计算（frame_door_children 里优先取 SingleDoor）
          const frameDoorBasePart = judgeIsMergeFrameDoor(part)
            ? part.frame_door_children.find(
                (child) => child?.plankType === 'SingleDoor'
              ) || part.frame_door_children[0]
            : part
          const targetPart = frameDoorBasePart || part
          // 将宽高恢复成默认顺序
          const oSizeRect = getOriginRect(targetPart)
          const oSizeCutRect = getOriginRect(targetPart, 'realRect')
          if (targetPart.srcTexDir == 'reverse') {
            const copyOSize = JSON.parse(JSON.stringify(oSizeRect))
            const copyOSizeCut = JSON.parse(JSON.stringify(oSizeCutRect))
            oSizeRect.width = copyOSize.height
            oSizeRect.height = copyOSize.width
            oSizeCutRect.width = copyOSizeCut.height
            oSizeCutRect.height = copyOSizeCut.width
          }
          // 定义特殊字段
          // 成品尺寸
          targetPart.oSize = `${(+oSizeRect.height).toFixed(
            2
          )}*${(+oSizeRect.width).toFixed(2)}*${targetPart.thick}`

          // 切割尺寸应该就是原始的尺寸，但是这里后端加上了预铣值
          const width =
            oSizeCutRect.width -
            Number(targetPart.edgePreMillingInfo?.width * 2 || 0)
          const height =
            oSizeCutRect.height -
            Number(targetPart.edgePreMillingInfo?.width * 2 || 0)
          // 切割尺寸
          targetPart.cutSize = `${height.toFixed(2)}*${width.toFixed(2)}*${
            targetPart.thick
          }`
          // 材质
          targetPart.matCode_texture = `${dealHighlightMatCode(
            targetPart._oriMatCode || targetPart.matCode
          )}-${
            targetPart._oriTexture ||
            targetPart.oriTexture ||
            targetPart.texture
          }`

          targetPart.handle_name = ''
          if (
            targetPart.handle &&
            targetPart.handle.partsChildren &&
            targetPart.handle.partsChildren.length
          )
            targetPart.handle_name =
              targetPart.handle.partsChildren[0].maskPartName ||
              targetPart.handle.partsChildren[0].matSpec
                ? `${
                    targetPart.handle.partsChildren[0].maskPartName ||
                    targetPart.handle.partsChildren[0].matSpec
                  }_${targetPart.handle.partsChildren[0].name}`
                : ''

          if (Array.isArray(targetPart.partsChildren)) {
            targetPart.partsChildren.forEach((p_c) => {
              if (p_c.name.includes('铰链'))
                targetPart.hinge_label = p_c.maskPartName || p_c.matSpec || ''
              else if (p_c.name.includes('拉直器'))
                targetPart.straightener_label =
                  p_c.maskPartName || p_c.matSpec || ''
            })
          }
        })
      })
      let tagLength = 0
      // this.all_page = len
      for (let i = 0; i < data.length; i++) {
        let plank = data[i]
        plank.parts = plank.parts.sort(compare('priority', 'up', 'priority'))
        tagLength += plank.parts.length
      }
      this.source_data = data
      // 给数据添加auto_index
      this.generateLabelNo(this.source_data)
      this.default_sort_source_data = data
      this.$store.commit('setTagListLength', tagLength)
      if (this.jx_checked && !this.isNewTagDraw) {
        this.source_data = JxTagData(this.source_data)
        this.default_sort_source_data = JxTagData(this.default_sort_source_data)
      }
    },
    /** 生成余料数据 **/
    initLaveData() {
      this.lave_data = []
      // 筛选数据
      const data = this.selectViewData(this.source_data)
      data.forEach((item, idx) => {
        const usedRate = item.realUsedRate
        const usedArea = item.realAreaTotal
        // 是否生成余料标签
        const isGenerateLaveTag = judgeIsGenerateLaveTag(usedRate, usedArea)

        let supplus = [item.parts]
        if (!supplus.length || !isGenerateLaveTag) return
        supplus.forEach((sup) => {
          let panel = {
            texture: item.texture,
            oriTexture: item._oriTexture || item.oriBigTexture,
            orderNo: sup[0].orderNo,
            roomName: sup[0].roomName,
            matCode: sup[0].matCode,
            parts: sup,
            thick: sup[0].thick,
            plankHeight: item.plankHeight,
            plankWidth: item.plankWidth,
            plankSize: '',
            lableImgName: new Date().getTime(),
            surplusInfo: item.surplusInfo,
            plank_index: idx + 1,
            plankIndex: idx,
          }
          if (sup[0].specialType === 'supplus') {
            panel.plankSize = getSurplusSize(
              sup[0],
              this.$store.state.ncSetting
            ).str
          }
          if (
            this.need_lave &&
            (!item.surplusInfo || item?.surplusInfo?.other_plate)
          ) {
            this.lave_data.push(panel)
          }
          if (
            this.need_lave_surplus &&
            item.surplusInfo &&
            !item.surplusInfo?.other_plate
          ) {
            this.lave_data.push(panel)
          }
        })
      })
    },
    // 生成标签序号
    generateLabelNo(data) {
      const start = this.ncSetting?.front_labeling_start_num || '0'
      const _no = Number(start) - 1
      if (data && data.length) {
        data.forEach((item) => {
          item.parts.forEach((it) => {
            it.auto_index = this.generateId(start, _no + it.priority)
          })
        })
      }
    },
    generateId(initStart, id) {
      let _id = id + ''
      if (_id.length < initStart.length) {
        _id = _id.padStart(initStart.length, 0)
      }
      return _id
    },
    // 刷新tagList要渲染的数据来源
    async refreshTagListSourceData() {
      if (this.tagListSourceData.length && this.isSameTypeSet) {
        return
      }
      this.tagListSourceData = []
      const allTagList = []
      let bigTagList = []

      // 更改小板的startX 更改孔槽的所在面 也就是左右翻面 应急码 TURNBLANK 贴标机设置需要贴标机开启时才生效
      if (
        this.ncSetting?.emergence_setting_key?.includes('TURNBLANK') &&
        this.ncSetting.labelOverturn &&
        this.ncSetting?.labelingMachine
      ) {
        rollOverTag(this.source_data, this.ncSetting)
      }

      const process_line_id =
        this.ncSetting.process_setting_id ?? this.ncSetting.process_line_id

      const isGenFiveSixDir = this.five_six_dir

      if (process_line_id) {
        const referenceRes = await fetchPlankReference({
          process_setting_id: process_line_id,
          bigPlanks: dealDrawDataForTag(this.source_data),
        })

        if (referenceRes.status) {
          const planks = dealDrawDataForTag(
            JSON.parse(referenceRes.data.bigPlanks)
          )
          this.source_data = planks
        } else {
          if (referenceRes.status === 0 && referenceRes?.msg) {
            this.$message.error(
              `获取放板基准数据错误，请稍后再试！${referenceRes.msg}`
            )
          } else {
            this.$message.error(
              translateLang('获取放板基准数据错误，请稍后再试！')
            )
          }
          return
        }
      }
      const isTemp = this.$route.query.from === 'temp'
      for (let index = 0; index < this.source_data.length; index++) {
        const isSurplusPlank =
          this.source_data[index].surplusInfo &&
          !this.source_data[index].surplusInfo?.other_plate

        const plank = this.source_data[index] // 大板
        let parts = this.source_data[index].parts // 该大版下的小板
        const { size } = getGraghEdge(plank)
        let ncName = this.file_setting
          .map((item) => {
            if (item.value) {
              return item.value
            } else {
              const stockNumLength = this.nc_file_settings.stockNumLength
              if (item.label === 'stockNum' && stockNumLength) {
                let value = index + 1 + '' // 序号用第几块板，如果不对，就把this.source_data用stockNum进行排序
                return value.padStart(stockNumLength, '0')
              } else if (item.label === 'front') {
                return this.nc_file_settings.front || parts[0].front || '正面'
              } else if (item.label === 'matCode') {
                // 材质需要对高光名称单独处理
                return dealHighlightMatCode(plank.matCode) || parts[0].matCode
              } else if (item.label == 'high_gloss_side_reverse') {
                return plank.hasAutoRollOver
                  ? this.ncSetting.custom_high_gloss_reverse
                  : ''
              } else if (item.label === 'trim_edge') {
                // 如果是自定义修四边
                if (plank.margin.toString()?.includes(',')) {
                  const trimEdges = plank.margin.split(',')
                  return `上${trimEdges[0]}下${trimEdges[1]}左${trimEdges[2]}右${trimEdges[3]}`
                }
                return plank.margin ?? ''
              } else {
                return parts[0][item.label]
              }
            }
          })
          .filter(Boolean)
          .join(this.file_setting_delimiter)
        let headersIds = this.nc_file_settings.customizeSetting?.headerIds

        // 如果没有大板序号，手动加上
        if (!headersIds['大板序号']) {
          ncName = index + 1 + this.file_setting_delimiter + ncName
        }

        // nc导出设置里选择了正反面且开启了正反面合并，去掉正反面相关字段
        if (
          headersIds['正面/反面'] &&
          this.ncOutputSetting?.fileMerge?.doubleEdgeCombine
        ) {
          let frontStr = this.ncOutputSetting.fileNameSetting.front_info
            ? this.ncOutputSetting.fileNameSetting.front_info
            : '正面'
          let backStr = this.ncOutputSetting.fileNameSetting.back_info
            ? this.ncOutputSetting.fileNameSetting.back_info
            : '反面'
          const reg = new RegExp(
            `\\${this.file_setting_delimiter}${frontStr}|\\${this.file_setting_delimiter}${backStr}`,
            'gi'
          )
          ncName = ncName.replace(reg, '')
        }
        // 给ncName加上后缀
        ncName = `${ncName}.${this.ncNameSuffix}`
        let currentPageNum = 1
        if (
          this.cut_need_lave ||
          this.cut_need_lave_surplus ||
          this.gen_big_plank_surplus_tag ||
          this.gen_big_plank_tag
        ) {
          currentPageNum = allTagList.length + 1
        } else {
          currentPageNum =
            allTagList.filter(
              (item) => !item.part.specialType && item.type !== 'plank'
            ).length +
            index +
            1
        }
        // 大板
        if (
          (this.gen_big_plank_tag || this.gen_big_plank_surplus_tag) &&
          !plank.isDesMaterialNoCut
        ) {
          // 大板信息
          let plankObj = {
            plank,
            plank_index: index + 1, // 第几张大板
            part: {
              ...parts[0],
              page: currentPageNum, //第几页
            },
            type: 'plank',
          }
          // 大板绘制信息
          const normalPart = plank.parts.find((part) => !part.specialType)
          const plankDrawMsg = {
            programAddress: normalPart
              ? normalPart.address
              : plank.parts[0].address,
            orderNo: normalPart ? normalPart.orderNo : plank.parts[0].orderNo,
            material:
              plank.thick +
              dealHighlightMatCode(plank.matCode) +
              (plank.oriBigTexture || plank.texture),
            size,
            ncName,
            qrCode: ncName,
            plank_index: `第${plankObj.plank_index}张大板`,
            lable_index: ``,
          }
          // 把 plankDrawMsg、graghEdge 放到 plank 里面
          plankObj.plank = {
            ...plankObj.plank,
            plankDrawMsg,
          }

          const isSurplusPlank =
            plankObj.plank.surplusInfo &&
            !plankObj.plank.surplusInfo?.other_plate
          if (
            (this.gen_big_plank_surplus_tag && isSurplusPlank) ||
            (this.gen_big_plank_tag && !isSurplusPlank) ||
            (this.gen_big_plank_tag && this.gen_big_plank_surplus_tag) ||
            isTemp
          ) {
            allTagList.push(plankObj)
            bigTagList.push(plankObj)
          }
        }
        // 小板 and 裁切板
        if (
          this.gen_small_plank_tag ||
          this.gen_small_plank_tag_surplus ||
          this.cut_need_lave ||
          this.cut_need_lave_surplus ||
          this.gen_no_cut_tag
        ) {
          let newParts = parts
          for (let p_index = 0; p_index < newParts.length; p_index++) {
            if (!newParts[p_index].surplusInfo) {
              newParts[p_index].surplusInfo = plank?.surplusInfo
            }
            const isSmllPartTagForNor =
              newParts[p_index].specialType !== 'supplus' && !isSurplusPlank
            const isCutTagForNor =
              newParts[p_index].specialType === 'supplus' && !isSurplusPlank
            const isSmllPartTagForSur =
              newParts[p_index].specialType !== 'supplus' && isSurplusPlank
            const isCutTagForSur =
              newParts[p_index].specialType === 'supplus' && isSurplusPlank
            let obj = {
              plank: {
                ...this.source_data[index],
              },
              part: {
                ...(JSON.parse(JSON.stringify(newParts[p_index])) || {}),
                page: allTagList.length + 1,
                ncName,
              },
              plank_index: index + 1,
              part_index: p_index,
              currentPlank: newParts[p_index],
              type: 'tag',
            }
            // 默认模板永远只有一个，添加了直接跳过
            if (isTemp) {
              allTagList.push(obj)
              continue
            }
            if (
              this.gen_small_plank_tag &&
              isSmllPartTagForNor &&
              !newParts[p_index].isDesMaterialNoCut
            ) {
              pushSmallPlankTagWithSub(allTagList, obj, this.cur_template)
            }
            if (
              this.gen_small_plank_tag_surplus &&
              isSmllPartTagForSur &&
              !newParts[p_index].isDesMaterialNoCut
            ) {
              pushSmallPlankTagWithSub(allTagList, obj, this.cur_template)
            }
            if (this.cut_need_lave && isCutTagForNor) {
              allTagList.push(obj)
            }
            if (this.cut_need_lave_surplus && isCutTagForSur) {
              allTagList.push(obj)
            }
            if (this.gen_no_cut_tag && newParts[p_index].isDesMaterialNoCut) {
              allTagList.push(obj)
            }
          }
        }
      }

      allTagList.forEach((item, pageIndex) => {
        if (item.part) {
          item.part.page = pageIndex + 1
        }
      })
      this.tagListSourceData = allTagList
      if (bigTagList.length) {
        // 修改每个属性的label_index信息
        this.$nextTick(() => {
          bigTagList.forEach((item) => {
            item.plank.plankDrawMsg.lable_index = `第${item.part.page}/${this.all_page}页`
          })
        })
      }
    },
    // 刷新预料标签要渲染的数据来源
    async refreshLaveTagSourceData() {
      if (this.laveTagListSourceData.length && this.isSameTypeSet) {
        return
      }
      this.laveTagListSourceData = []
      for (let index = 0; index < this.lave_data.length; index++) {
        const plank = this.lave_data[index]
        if (checkIsOnlyProcessHoleSlotByPaibanData([plank], null)) {
          continue
        }
        const isSurplusPlank =
          plank?.surplusInfo && !plank?.surplusInfo?.other_plate
        let obj = {
          plank,
          plank_index: plank.plank_index ?? index + 1,
          type: 'laveTag',
        }
        if (isSurplusPlank && this.need_lave_surplus) {
          this.laveTagListSourceData.push(obj)
        }
        if (!isSurplusPlank && this.need_lave) {
          this.laveTagListSourceData.push(obj)
        }
      }
    },
    /** 开始渲染 todo 用下面的方法临时处理重复问题 **/
    // async startRender() {
    //   // 根据上下料选项重置数据
    //   this.resetUpDownMaterialData()
    //   await this.refreshTagListSourceData()
    //   this.refreshLaveTagSourceData()
    //   // 重新渲染重置，会一直积累
    //   this.collect = []
    //   this.loadTagList(true, this.useLoadMore ? false : true)
    // },
    /** 临时将上面的 startRender 方法复制下来处理，解决一下重复问题 */
    async startRender() {
      this.isLoadWaitting = true
      this.isSameTypeSet = false
      if (this.isPaibanDataChange) {
        this.currentBigpart = null
      }
      transformToEzSort.clear()
      this.cut_progress = 0

      // 根据上下料选项重置数据
      this.resetUpDownMaterialData()
      await this.refreshLaveTagSourceData()
      await this.refreshTagListSourceData()
      // 重新渲染重置，会一直积累
      this.collect = []
      this.loadTagList(true, this.useLoadMore ? false : true)
    },

    /**
     * needTranslate: 是否需要转换成svg或者图片
     */
    async preparePrintData(
      tag_type = 'base64',
      scale = 1,
      needTranslate = true,
      paibanData = this.paibanData
    ) {
      let print_data = [],
        print_data_qt = []
      const separator = this.$store.state.ncSetting.label_image_name_separator
      this.showLoading = true
      let url = ''
      // 大板序号补偿位数 默认1
      const stockNumOffset =
        this.$store.state.ncSetting.labelingSetting?.stockNumOffset ??
        defaultStockNumOffset
      // if (needTranslate) {
      // url = await createTag(
      //   this.cur_template,
      //   this.source_data[index],
      //   JSON.parse(JSON.stringify(parts[p_index])),
      //   index + 1,
      //   p_index,
      //   this.all_page,
      //   this.jx_checked,
      //   this.five_six_dir,
      //   { scale: scale, canvas: 'print-tag', type: tag_type },
      //   this.$store.state.ncSetting,
      //   parts[p_index]
      // )
      // }
      let ncFileList = this.ncFileList
      const ncCustomLabel = this.ncSetting.label_image_name_type ?? []
      let ncFileName = ''
      let labelFileName = ''
      let ncAutoIndex = ''
      if (
        (ncCustomLabel.some((type) =>
          ['labeling_filename', 'nc_filename', 'auto_index'].includes(type)
        ) ||
          this.ncSetting.label_img_big_plank_folder) &&
        !ncFileList.length
      ) {
        // 对小板类的切割顺序按照升序排列
        let paibanDataCopy = deepCopy(this.paibanData)
        this.generateLabelNo(paibanDataCopy)
        paibanDataCopy.forEach((item) => {
          // 用于混排字段处理， 后端要求texture和oriTexture一致都表示原始值，newTexture表示新的值
          item.parts.forEach((part) => {
            part.texture = this.isNewTagDraw
              ? part.oriTexture
              : part._oriTexture || part.oriTexture
            part.newTexture = part.texture
          })
          item.parts.sort((a, b) => a.priority - b.priority)
        })
        // xy互换大板的四边修边已经转了，传给nc要转回去
        paibanDataCopy = paibanDataCopy.map((plank) => ({
          ...plank,
          margin: fourTrimEdge(
            String(
              plank.surplusInfo && plank.surplusInfo.is_plus
                ? plank.isUseSaw
                  ? plank.margin
                  : this.$store.state.selectStandardPlank.plankEdgeOff
                : plank.margin
            ),
            this.ncSetting
          ),
        }))
        const newData = changeDataStartPoint(paibanDataCopy)
        newData.forEach((item) => {
          const surplusIndo = item.surplusInfo
          if (
            surplusIndo &&
            surplusIndo.is_plus &&
            surplusIndo.shape == 'lshape' &&
            surplusIndo.path &&
            surplusIndo.path.length
          ) {
            Object.assign(
              item.surplusInfo,
              dealLshapeTurnPoints(surplusIndo.path)
            )
          }
          item.parts = item.parts.filter((it) => !it.blueAreaSurplus)
        })
        // 添加封边描述信息
        newData.forEach((item) => {
          item.parts.forEach((part) => {
            part.edgeInfo_desc_LW = getEdgeTypeWithRect(
              part.edgeInfo,
              part.rect
            )
          })
        })

        newData.forEach((item) => {
          item.parts.forEach((part) => {
            if (judgeIsMergeFrameDoor(part)) {
              // 清掉合并骨骼门 为绘制所构造的线槽数据（如果不删除 后端会去加工）
              part.lineSlots = []
            }
          })
        })

        newData.forEach((item) => {
          item.parts = item.parts.map((part) => pickNcPartFields(part))
        })
        const ncRequestPayload = {
          uid: this.userInfo.id,
          data: JSON.stringify(newData),
          id:
            this.ncSetting.process_setting_name == '默认生产线'
              ? -1
              : this.ncSetting.process_setting_id,
          keepKnifeOrigin: true,
          from: 'web',
          embedded: sessionStorage.getItem('embedded') ? 1 : 0,
          guigui_version: sessionStorage.getItem('guigui_version'),
          version: 'v1',
          longPlankCuttingSetting: this.ncSetting.longPlankCuttingSetting,
        }
        if (this.isNewTagDraw) {
          ncRequestPayload.from_label = true
        }
        const nc = await httpRequest.post('new_nc', ncRequestPayload)
        if (nc?.data?.knife_error || nc.status === 0) {
          this.showLoading = false
          this.isPrintFlag = false
          this.export_loading = false
          this.$confirm(`${nc.msg}`, '警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'error',
          })
          throw '找不到刀报错'
        }
        ncFileList = nc.data
      }

      const tagArray = this.isNewTagDraw ? this.tagList : this.tagListSourceData
      let collectIdx = 0
      for (let index = 0; index < tagArray.length; index++) {
        let item = tagArray[index]
        if (item.skipRender) {
          continue
        }

        if (!this.isNewTagDraw) {
          let isGenPrintData = !this.batchTaggingList.length
          if (this.batchTaggingList.length) {
            isGenPrintData =
              (isPartTagType(item.type) && item.part.isBatchTagging) ||
              (item.type === 'plank' &&
                item.plank.parts.some((part) => part.isBatchTagging))
          }
          if (!isGenPrintData) {
            continue
          }
        }

        let fileName = ''
        if (this.isNewTagDraw) {
          item.part = item.part ?? item.plank.parts[0]
        }
        let ncFileName = dealFileArrfunc(item.plank, ncFileList, 'nc')
        let labelFileName = dealFileArrfunc(item.plank, ncFileList, 'label')
        let ncAutoIndex = dealFileArrLabel(item.part, ncFileList)

        const { front_file_identifier } = this.ncSetting
        const fileNameMap = new Map([
          ['address', item.part['address']],
          ['orderNo', item.part['orderNo']],
          ['nc_filename', ncFileName],
          ['labeling_filename', labelFileName],
          [
            'plankNum',
            this.ncSetting.genSimpleLabelBarcode
              ? item.part.simplePlankNum
              : item.part['plankNum'],
          ],
          ['auto_index', ncAutoIndex],
          [
            'stockNum',
            plankOrderCompensationDigits(item.plank_index, stockNumOffset),
          ],
          ['priority', item.part['priority']],
          ['labelId', item.part['labelId']],
        ])

        let plankNum = this.ncSetting.genSimpleLabelBarcode
          ? item.part.simplePlankNum
          : item.part['plankNum']
        if (
          item.part.specialType == 'supplus' ||
          (item.part.surplusPath && item.part.surplusPath.length > 0) ||
          (this.isNewTagDraw && item.type == 'surplus' && !item.isRestTag)
        ) {
          plankNum += front_file_identifier
        }
        fileNameMap.set('plankNum', plankNum)

        if (item.type === 'plank') {
          fileName = `${plankOrderCompensationDigits(
            item.plank_index,
            stockNumOffset
          )}`
        } else if (
          this.isNewTagDraw &&
          (item.type === 'lave' || item.isRestTag)
        ) {
          const labelImageName = new Date().getTime()
          fileName = `${labelImageName}${separator}${plankOrderCompensationDigits(
            item.plank_index,
            stockNumOffset
          )}`
        } else {
          fileName = ncCustomLabel.length
            ? ncCustomLabel.map((type) => fileNameMap.get(type)).join(separator)
            : `${
                item.part.lableImgName
              }${separator}${plankOrderCompensationDigits(
                item.plank_index,
                stockNumOffset
              )}${separator}${item.part['priority']}`
        }
        fileName = appendSubTagFileNameSuffix(fileName, item)
        if (isPartTagType(item.type)) {
          transformToEzSort.changeImageFileName(
            item.part,
            fileName,
            this.ncSetting?.labelImageFormat,
            index
          )
        }

        url = this.isNewTagDraw ? item?.src : this.collect[collectIdx]
        collectIdx++

        if (this.isNewTagDraw) {
          print_data.push({
            name: fileName,
            plank_index: item.plank_index,
            type: item.type,
            part: item.part,
          })
        } else {
          print_data.push({ name: fileName, plank_index: item.plank_index })
        }
        if (tag_type !== 'svg') {
          const urlReg = this.isNewTagDraw
            ? /^data:image\/(png|jpg|jpeg|bmp);base64,/
            : /^data:image\/(png|jpg|jpeg);base64,/
          print_data_qt.push({
            name: fileName,
            url: needTranslate && url ? url?.replace(urlReg, '') : '',
          })
        }
      }
      this.ncFileList = ncFileList
      this.showLoading = false
      this.export_loading = false
      this.export_loading_text = '导出图片'
      // 获取板件是否需要逆时针旋转
      let isRotatePlank = false
      const typographyKlass = this.cur_template.tem_data.find(
        (it) => it.type === 'Typography'
      )
      if (typographyKlass) {
        isRotatePlank = typographyKlass.data.plankRotate
      }
      if (this.need_lave || this.need_lave_surplus) {
        if (!this.isNewTagDraw) {
          for (let index = 0; index < this.lave_data.length; index++) {
            let url = ''
            const laveItem = this.lave_data[index]
            // 批量补标签时 只处理有补标签标志的板
            if (
              !this.batchTaggingList.length ||
              (this.batchTaggingList.length &&
                laveItem.parts.some((part) => part.isBatchTagging))
            ) {
              if (needTranslate) {
                url = await createLaveTag(
                  this.cur_template,
                  laveItem,
                  index + 1,
                  { scale: scale, canvas: 'print-tag', type: tag_type },
                  this.$store.state.ncSetting,
                  false,
                  isRotatePlank,
                  this.all_page,
                  this.part_page,
                  index
                )
              }
              const fileName = `${
                laveItem.lableImgName
              }${separator}${plankOrderCompensationDigits(
                index + 1,
                stockNumOffset
              )}`
              if (this.is_lave_tag_end || this.is_lave_tag_end_sur) {
                const startIndex = print_data.findIndex(
                  (item) => item.plank_index == laveItem.plank_index
                )
                const insertIndex = print_data.filter(
                  (item) => item.plank_index == laveItem.plank_index
                ).length
                print_data.splice(startIndex + insertIndex, 0, {
                  name: fileName,
                  plank_index: laveItem.plank_index,
                  url,
                })
                if (tag_type !== 'svg') {
                  print_data_qt.splice(startIndex + insertIndex, 0, {
                    name: fileName,
                    url: needTranslate
                      ? url.replace(/^data:image\/(png|jpg|jpeg);base64,/, '')
                      : '',
                  })
                }
              } else {
                print_data.push({ name: fileName, url })
                if (tag_type !== 'svg') {
                  print_data_qt.push({
                    name: fileName,
                    url: needTranslate
                      ? url.replace(/^data:image\/(png|jpg|jpeg);base64,/, '')
                      : '',
                  })
                }
              }
            }
          }
        }
      }

      let template_name = this.template_list.filter((v) => {
        return v.id === this.active_template_id
      })[0].name

      return { print_data, print_data_qt, template_name }
    },
    // 生成所有的渲染taq
    async genAllRenderTag() {
      this.showLoading = true
      // this.isPrintFlag = true
      await this.loadTagList(false, true)
      this.showLoading = false
      this.isPrintFlag = false
      this.export_loading = false
      this.export_loading_text = translate('common.exportPic')
    },
    async printPre() {
      if (!(await this.checkIsExport())) return
      buryPointApi('tag', 'print')
      if (this.inQt) {
        // 如果在qt就直接执行print()方法
        this.print()
        return
      }
      // 只提示一次
      let printFlag = localStorage.getItem('printFlag')
      this.isPrintFlag = true
      if (printFlag) {
        this.print()
        return
      }
      localStorage.setItem('printFlag', true)
      // this.$confirm(
      //   '首次使用直接打印时，请在打印机设置中新增一张使用的该尺寸且长、宽对调的纸张，然后使用新增纸张进行打印  （例：原纸张尺寸60X40，新增纸尺寸40X60）',
      //   '提示',
      //   {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     // type: 'warning',
      //   }
      // )
      //   .then(() => {
      //     dom.style.display = 'none'
      //     this.print()
      //   })
      //   .catch(() => {
      //   })
      // 首次打印提示
      this.$antdConfirm({
        title: this.translateLang('common.tip'),
        content: this.translateLang('printPage.firstPrintTip'),
        okText: this.translateLang('common.confirm'),
        cancelText: this.translateLang('common.cancel'),
        centered: true,
        // icon: () => createVNode(ExclamationCircleOutlined),
        icon: 'exclamation-circle',
        onOk: () => {
          const dom = document.querySelector('.ant-modal-confirm')
          dom.style.display = 'none'
          this.print()
        },
        onCancel: () => {},
      })
    },
    /** 打印 **/
    async print() {
      if (!(await validateSubTagPerForExport(this.cur_template))) {
        return
      }
      this.exportType = 'print'
      let hasGenAllCollect
      if (this.isNewTagDraw) {
        this.collect = this.tagList
        hasGenAllCollect = this.tagList.length && !this.isCanDownLoading
      } else {
        hasGenAllCollect =
          this.need_lave || this.need_lave_surplus
            ? this.collect.length === this.renderDataList.length
            : this.collect.length > this.tagListSourceData.length
      }

      if (!hasGenAllCollect) {
        await this.genAllRenderTag()
      }

      this.$htm_trackEvent('直接打印标签', 'click')
      this.export_loading = true
      this.export_loading_text = '准备数据中...'
      this.isPrintFlag = true
      this.showLoading = true
      this.export_loading = false

      let print_data = await this.preparePrintData()
      // !this.isSubPrintTag && this.autoSaveHistory()
      this.autoSaveHistory()
      // return
      if (typeof window.webToQt !== 'undefined') {
        webToQt.webLabelPdfToQtV2(
          {
            fileName: `${print_data.template_name}.pdf`,
            imgArr: print_data.print_data_qt.map((v) => {
              return v.url
            }),
            tagWidth: this.cur_template.tag_width,
            tagHeight: this.cur_template.tag_height,
          },
          'print'
        )
        this.showLoading = false
        this.isPrintFlag = false

        return
      }
      if (typeof window.webToQt !== 'undefined') {
        this.derivePdf()
        this.showLoading = false
        this.isPrintFlag = false

        return
      }
      let isPrintTags = [
        ...this.tag_svg_list,
        ...Object.values(this.lave_svg_list),
      ]
      this.$store.commit('savePrintData', {
        data: isPrintTags.map((v) => {
          return {
            width: this.cur_template.tag_width,
            height: this.cur_template.tag_height,
            url: v,
          }
        }),
        setting: this.print_setting,
      })
      let collect =
        this.need_lave || this.need_lave_surplus
          ? this.collect
          : this.collect.slice(0, this.tagListSourceData.length)
      this.$store.commit('saveCollect', collect)
      const dpi = getDeviceXDPI()
      // 获取模板标签对应的像素宽度
      const templateWidthPx = mmToPx(this.cur_template.tag_width, dpi)
      const tagDom = document.querySelector('.render_svg_item')
      // 标签对应的宽度
      const tagWidth = tagDom.offsetWidth
      // 这个比例是标签转换为模板大小实际要进行的缩放
      const tagScale = templateWidthPx / tagWidth
      this.$store.commit('setTagScale', tagScale)

      // 给打印标签加上标记（方便在打印页面设置样式）
      this.isPrintTagMark = true
      // 保存标签列表对应的dom
      let tagListDom = document.querySelector('.print_tag_list')
      let tagListDomString = tagListDom.innerHTML
      this.$store.commit('savetagListDomString', tagListDomString)
      this.showLoading = false
      this.isPrintFlag = false

      // 去掉标记
      this.isPrintTagMark = false
      this.$router.push({
        path: '/print',
        query: { scale: this.canvas_scale },
      })
    },
    async svgListToPdfJSBinary(svgList, options = {}) {
      const doc = new jsPDF(options)
      // 1. 遍历 SVG 元素数组
      for (let i = 0; i < svgList.length; i++) {
        if (i !== 0) doc.addPage()
        const svg = svgList[i]
        // 2. 将 SVG 字符串解析为 DOM 元素
        const parser = new DOMParser()
        const svgElement = parser.parseFromString(
          svg,
          'image/svg+xml'
        ).documentElement
        /**
         * 这里说一下为什么需要这么做，因为在 svg2pdf 的源码中他在获取元素上的字体，然后会采用这个字体，如果不存在它
         * 第一：会报解析错误
         * 第二：如果解析到没有 font-family 属性它会采用默认的 times字体，会导致中文乱码
         * 第三：如果字重不是数字形式的内部也会解析出现问题
         * 第四：可能是我没有看完源码中的解析流程，如果后续有大佬了解此包运行逻辑请务必修改此处糟糕的逻辑（😁）
         */
        svgElement.style.fontFamily = 'msyh'
        svgElement.querySelectorAll('tspan').forEach((el) => {
          const parent = el.parentElement
          const fontFamily = parent?.getAttribute('font-family') || '微软雅黑'
          el.setAttribute('font-family', fontFamilyMap[fontFamily])
          const inheritedFontWeight =
            parent?.getAttribute('font-weight') || '400'
          el.setAttribute(
            'font-weight',
            inheritedFontWeight === 'bold' ? '700' : '400'
          )
        })
        svgElement.querySelectorAll('text,rect').forEach((el) => {
          const fontFamily = el?.getAttribute('font-family') || '微软雅黑'
          el.setAttribute('font-family', fontFamilyMap[fontFamily])
        })
        await doc.svg(svgElement, {
          removeInvalid: true,
          width: this.cur_template.tag_width,
          height: this.cur_template.tag_height,
        })
      }
      return doc.output('arraybuffer')
    },
    /** 导出pdf **/
    async exportPdf() {
      if (!(await this.checkIsExport())) return
      if (!(await validateSubTagPerForExport(this.cur_template))) {
        return
      }
      buryPointApi('tag', 'export_pdf')
      transformToEzSort.setPattern('pdf')
      this.exportType = 'pdf'
      this.pdfPageCount = 0
      // const QtFrom = sessionStorage.getItem('QtFrom')
      this.$htm_trackEvent('导出标签pdf', 'click')
      this.export_loading = true
      this.export_loading_text = `${translate('common.exportPDF')}...`
      setTimeout(() => {
        this.isTimeOut = true
      }, 20000)
      // 全局排版导出pdf自动保存历史
      // !this.isSubPrintTag && this.autoSaveHistory()
      this.autoSaveHistory()
      /** 创建pdf实例 */
      // if(QtFrom === 'guigui') {
      //   let print_data = await this.preparePrintData();
      //   if (typeof window.webToQt !== 'undefined') {
      //     this.export_loading = false;
      //     webToQt.webLabelPdfToQtV2({
      //       fileName: `${print_data.template_name}.pdf`,
      //       imgArr: print_data.print_data_qt.map(v=> { return v.url; }),
      //       tagWidth: this.cur_template.tag_width,
      //       tagHeight: this.cur_template.tag_height,
      //     }, 'pdf');
      //     return;
      //   }
      // }
      // 新版guigui的下载走pdf绘制方式
      // if(QtFrom === 'guigui2') {
      //   if (typeof window.webToQt !== 'undefined') {
      //     this.export_loading = false;
      //     webToQt.webLabelPdfToQtV2({
      //       fileName: `${template_name}.pdf`,
      //       imgArr: [QTBase64Url],
      //       tagWidth: this.cur_template.tag_width,
      //       tagHeight: this.cur_template.tag_height,
      //       }, 'pdf');
      //       return;
      //   }
      // }
      this.derivePdf()
      this.isTimeOut = false
      this.export_loading = false
    },
    // 等待生成完毕
    async waitGenAll() {
      // this.showLoading = true
      return new Promise((resolve) => {
        bus.$on('waitGenAll', () => {
          resolve()
          // this.showLoading = false
          // this.isPrintFlag = false
          bus.$off('waitGenAll')
        })
      })
    },
    waitNewTagDrawReady() {
      return new Promise((resolve) => {
        if (!this.isTagLoading && !this.isCanDownLoading) {
          resolve()
          return
        }
        const timer = setInterval(() => {
          if (!this.isTagLoading && !this.isCanDownLoading) {
            clearInterval(timer)
            resolve()
          }
        }, 100)
      })
    },
    getBase64FromDataUrl(dataUrl) {
      if (!dataUrl) {
        return ''
      }
      const str = String(dataUrl)
      const commaIndex = str.indexOf(',')
      return commaIndex > -1 ? str.slice(commaIndex + 1) : str
    },
    /** 导出图片 **/
    async exportImg() {
      if (!(await this.checkIsExport())) return
      if (!(await validateSubTagPerForExport(this.cur_template))) {
        return
      }
      // 检查本地所使用的目录是否存在
      if (!(await this.$refs.folderChooseModalRef?.verify())) {
        return
      }
      // 按钮禁用
      if (
        this.print_color_tag &&
        this.$store.state.ncSetting.labelImageFormatNew == 'bmp' &&
        this.$store.state.ncSetting.bmp_color_style == 1
      ) {
        return
      }
      transformToEzSort.setPattern('img')
      // 检测标签图片是否按大板分不同文件夹时 是否勾选了小板标签
      let nc_setting
      if (this.ncSetting?.process_setting_id) {
        const nc_setting_res = await fetchGetProductionNcSetting({
          setting_id: this.ncSetting?.process_setting_id,
        })
        if (nc_setting_res.data) nc_setting = nc_setting_res.data
      }
      const { label_img_big_plank_folder, isMergeFile } =
        nc_setting || this.ncSetting
      if (
        label_img_big_plank_folder &&
        !isMergeFile &&
        (!this.gen_small_plank_tag || !this.gen_small_plank_tag_surplus)
      ) {
        this.$message.warning(this.$t('common.downImageErrTip'))
        return
      }
      buryPointApi('tag', 'export_img')
      this.exportType = 'image'
      this.isTimeOut = true

      await this.timer(20)
      const time = Date.now()
      // 一级文件名
      let firstLevelFileName = ''
      let originFileNameData = {}
      try {
        let obj = await genFirstLevelFileName(true)
        firstLevelFileName = obj.firstLevelFileName
        originFileNameData = obj.data
      } catch (error) {}
      // 因为collect可能会收集部分的余料，所以做如下判断
      let hasGenAllCollect = this.need_lave
        ? this.collect.length === this.renderDataList.length
        : this.collect.length >= this.tagListSourceData.length
      // 批量补标签 大概率collect是小于renderDataList和tagListSourceData。所以直接简单粗暴设为true，false进入到waitGenAll会卡住
      if (this.batchTaggingList.length) {
        hasGenAllCollect = true
      }
      if (!this.isNewTagDraw && !hasGenAllCollect) {
        if (this.useLoadMore) {
          await this.genAllRenderTag()
        } else {
          this.showLoading = true
          await this.waitGenAll()
          this.showLoading = false
          this.export_loading = false
          this.export_loading_text = '导出图片'
        }
      }
      if (this.isNewTagDraw && (this.isTagLoading || this.isCanDownLoading)) {
        this.showLoading = true
        this.export_loading = true
        this.export_loading_text = '导出图片中...'
        await this.waitNewTagDrawReady()
        this.showLoading = false
      }
      // 根据need_lave得到最终的图片列表
      let collect =
        this.need_lave || this.need_lave_surplus
          ? this.collect
          : this.collect.slice(0, this.tagListSourceData.length)
      if (this.isNewTagDraw) {
        collect = this.tagList.map((tag) => tag.src)
      }
      this.export_loading = false
      this.export_loading_text = '导出图片'
      this.showLoading = false
      this.$htm_trackEvent('导出标签图片', 'click')
      this.export_loading = true
      this.export_loading_text = '导出图片中...'
      // let time2 = Date.now();

      // 生成svg所需要的时间
      // let print_data = await this.preparePrintData("base64", 3);
      // 这儿主要用到里面的一些名字信息

      const data = this.currentBigpart ? [this.currentBigpart] : this.paibanData
      let print_data = await this.preparePrintData('svg', 3, false, data)

      const imgFileName =
        originFileNameData.label_image_folder || print_data.template_name
      // 创建图片转bmp实例
      const labelImage = this.$store.state.ncSetting.labelImageFormatNew
      const bmp_color_style = this.$store.state.ncSetting?.bmp_color_style
      // 内嵌云排版执行

      if (typeof window.webToQt !== 'undefined') {
        this.export_loading = false
        this.showLoading = false
        this.isPrintFlag = false
        // let originFileName = firstLevelFileName
        //   ? `${firstLevelFileName}/${imgFileName}`
        //   : print_data.template_name
        // let originFileName = imgFileName || print_data.template_name
        // 在此处判断贴标图片文件是否需要生成文件夹
        let originFileName = ''
        if (
          this.$store.state.ncSetting.customizeFolder?.required_folders?.indexOf(
            'label_image_folder'
          ) !== -1
        ) {
          originFileName = imgFileName || '贴标图片'
        }
        const newConllect = []
        const qtPrintData = await this.preparePrintData('base64', 3, true, data)

        if (labelImage && labelImage === 'bmp' && bmp_color_style == 1) {
          for (let i = 0; i < qtPrintData.print_data_qt.length; i++) {
            const qtUrl = qtPrintData.print_data_qt[i]?.url
            if (!qtUrl) {
              newConllect.push('')
              continue
            }
            const dataUrl = qtUrl.startsWith('data:')
              ? qtUrl
              : `data:image/png;base64,${qtUrl}`
            const re = await exportBmp1Bit(dataUrl)
            newConllect.push(re)
          }
        }

        const imgArr = []
        for (let index = 0; index < qtPrintData.print_data.length; index++) {
          const v = qtPrintData.print_data[index]
          let url = ''
          if (labelImage && labelImage === 'bmp' && bmp_color_style == 1) {
            url = this.getBase64FromDataUrl(newConllect[index])
          } else {
            url = qtPrintData.print_data_qt[index]?.url ?? ''
          }
          if (!url) {
            continue
          }
          imgArr.push({
            url,
            fileName: `${v.name}.${
              this.$store.state.ncSetting.labelImageFormat || 'jpg'
            }`,
          })
        }

        if (!imgArr.length) {
          this.export_loading = false
          this.export_loading_text = '导出图片'
          this.$message.warning('标签图片尚未生成完成，请稍后再试')
          return
        }

        // 将imgArr分成多份，每份最多500
        const imgArrChunks = imgArr.reduce((acc, curr, index) => {
          const chunkIndex = Math.floor(index / 500)
          if (!acc[chunkIndex]) {
            acc[chunkIndex] = []
          }
          acc[chunkIndex].push(curr)
          return acc
        }, [])

        if (!this.isNewTagDraw) {
          window.webToQt.webLabelImgToQt({
            tagWidth: this.cur_template.tag_width,
            tagHeight: this.cur_template.tag_height,
            imgArr: imgArr,
            originFileName: `${originFileName}`,
          })
          return
        }
        for (let index = 0; index < imgArrChunks.length; index++) {
          const chunk = imgArrChunks[index]
          window.webToQt.webLabelImgToQt({
            tagWidth: this.cur_template.tag_width,
            tagHeight: this.cur_template.tag_height,
            imgArr: chunk,
            originFileName: `${originFileName}`,
            isRefresh: index < 1,
            isLastChunk: index === imgArrChunks.length - 1,
          })
        }
        return
      }
      let zip = new JSZip()
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let self = this
      let currentZip = zip
      // 收集的bmp图片数组
      const bmpList = []
      if (labelImage && labelImage === 'bmp') {
        for (let i = 0; i < collect.length; i++) {
          let item = collect[i]

          if (this.ncSetting.bmp_color_style) {
            const newBase64 = await exportBmp1Bit(item)
            item = newBase64
            bmpList.push(item)
          } else {
            const imgUrl = await convertJpegToBmp.convertJpegToBmp(item)
            bmpList.push(imgUrl)
          }
        }
      }
      if (bmpList.length) {
        collect = bmpList
      }
      const _ncFileList = this.ncFileList.filter(
        (i) => i.filetype === 'nc' && i.direction === 'front'
      )
      let idx = 0
      if (label_img_big_plank_folder && !isMergeFile) {
        let folders
        if (
          this.$store.state.ncSetting.customizeFolder.required_folders?.indexOf(
            'label_image_folder'
          ) !== -1
        ) {
          folders = zip.folder(imgFileName || '贴标图片')
        }
        for (let index = 0; index < this.source_data.length; index++) {
          const item = this.source_data[index]
          // 批量补标签时 只处理有补标签标志的板
          if (
            !this.batchTaggingList.length ||
            (this.batchTaggingList.length &&
              item.parts.some((part) => part.isBatchTagging))
          ) {
            const idy = _ncFileList.findIndex(
              (i) => i.stock_key === item.stockKey
            )
            const dirname = _ncFileList[idy].file_display_name.slice(0, -3)
            if (firstLevelFileName) {
              currentZip = (folders || zip).folder(`${dirname}`)
            }
            const labelImageFormatNew =
              this.$store.state.ncSetting.labelImageFormatNew
            // 没有勾选生成余料的情况过滤掉多的标签信息
            if (!this.cut_need_lave) {
              item.parts = item.parts.filter((i) => i.specialType !== 'supplus')
            }
            // 生成的每个文件夹中图片的数量
            let list = []
            if (this.need_lave && this.gen_big_plank_tag) {
              list = [
                this.bigplantLableList[item.canvasIndex],
                ...item.parts,
                this.LaveTagBase64List[item.canvasIndex],
              ]
            } else if (this.need_lave && !this.gen_big_plank_tag) {
              list = [...item.parts, this.LaveTagBase64List[item.canvasIndex]]
            } else if (!this.need_lave && this.gen_big_plank_tag) {
              list = [this.bigplantLableList[item.canvasIndex], ...item.parts]
            } else {
              list = [...item.parts]
            }
            // 过滤一下数据部分操作可能会导致没有数据存在
            list = list.filter(Boolean)
            // 是bmp图片格式
            if (labelImageFormatNew && labelImageFormatNew === 'bmp') {
              for (let indey = 0; indey < list.length; indey++) {
                const itey = list[indey]
                let it = collect[idx]?.split(',')[1]
                let filename = print_data.print_data[idx]?.name
                if (this.ncSetting.bmp_color_style) {
                  let base64Str = collect[idx]
                  if (
                    indey === list.length - 1 &&
                    this.need_lave &&
                    !this.batchTaggingList.length
                  ) {
                    // 当前文件夹余料标签的索引 = 图片列表的长度-文件夹的数量+当前生成的第几个文件夹
                    const currentIndex =
                      collect.length - this.source_data.length + index
                    base64Str = collect[currentIndex]
                    filename = print_data.print_data[currentIndex]?.name
                    idx--
                  }
                  it = base64Str?.split(',')[1]
                } else {
                  if (
                    indey === list.length - 1 &&
                    this.need_lave &&
                    !this.batchTaggingList.length
                  ) {
                    // 当前文件夹余料标签的索引 = 图片列表的长度-文件夹的数量+当前生成的第几个文件夹
                    const currentIndex =
                      collect.length - this.source_data.length + index
                    it = collect[currentIndex]?.split(',')[1] // 拿到的是余料标签
                    filename = print_data.print_data[currentIndex]?.name
                    idx--
                  }
                }
                if (filename && it) {
                  currentZip.file(
                    `${filename}.${
                      self.$store.state.ncSetting.labelImageFormat || 'jpg'
                    }`,
                    it,
                    { base64: true }
                  )
                }
                idx++
              }
            } else {
              list.forEach((itey, indey) => {
                // if (collect[idx]) {
                let it = collect[idx]?.split(',')[1]
                let filename = print_data.print_data[idx]?.name
                if (
                  indey === list.length - 1 &&
                  this.need_lave &&
                  !this.batchTaggingList.length
                ) {
                  // 当前文件夹余料标签的索引 = 图片列表的长度-文件夹的数量+当前生成的第几个文件夹
                  const currentIndex =
                    collect.length - this.source_data.length + index
                  it = collect[currentIndex]?.split(',')[1] // 获取到是对应的余料标签
                  filename = print_data.print_data[currentIndex]?.name
                  idx--
                }
                if (filename && it) {
                  currentZip.file(
                    `${filename}.${
                      self.$store.state.ncSetting.labelImageFormat || 'jpg'
                    }`,
                    it,
                    { base64: true }
                  )
                }
                idx++
              })
            }
          }
        }
      } else {
        if (
          this.$store.state.ncSetting?.customizeFolder?.required_folders?.indexOf(
            'label_image_folder'
          ) !== -1
        ) {
          currentZip = zip.folder(imgFileName || '贴标图片')
        }
        // 新版bmp格式
        const labelImageFormatNew =
          this.$store.state.ncSetting.labelImageFormatNew
        if (labelImageFormatNew && labelImageFormatNew === 'bmp') {
          for (let index = 0; index < collect.length; index++) {
            let url = collect[index].split(',')[1]
            // TODO 是否为位深1生成图片
            if (this.ncSetting.bmp_color_style) {
              const newBase64 = await exportBmp1Bit(collect[index])
              url = newBase64.split(',')[1]
            }
            currentZip.file(
              `${print_data.print_data[index].name}.${'bmp'}`,
              url,
              { base64: true }
            )
          }
        } else {
          collect.forEach((item, index) => {
            item = item.split(',')[1]
            currentZip.file(
              `${print_data.print_data[index].name}.${
                self.$store.state.ncSetting.labelImageFormat || 'jpg'
              }`,
              item,
              { base64: true }
            )
          })
        }
      }
      // 生成压缩包
      zip.generateAsync({ type: 'blob' }).then(async (content) => {
        self.export_loading = false
        const name = (
          firstLevelFileName ? firstLevelFileName : print_data.template_name
        ).replace(/\+/g, '_')
        let flag = false
        // 是否采用zip的形式导出 否则是采用文件直接写入
        if (
          this.$store.state.preferencesSetting.setting?.is_use_folder_export
        ) {
          flag = await savaFileToDisk(zip, name || '标签图片')
        }
        if (!flag) {
          FileSaver.saveAs(content, `${name}.zip`)
        }
        // 开启了发送至彩标
        if (this.$store.state.preferencesSetting.setting?.isSendToEzSort) {
          await transformToEzSort.processDownloadOpenEzsort(name)
        }
      })
      // 全局排版导出导出图片自动保存历史
      this.showLoading = true
      // !this.isSubPrintTag && this.autoSaveHistory()
      this.autoSaveHistory()
      this.$message.success(translate('common.downloadDoneByType'))
      this.isTimeOut = false
      this.showLoading = false
      this.isPrintFlag = false
      this.export_loading = false
      this.export_loading_text = translate('common.exportPic')
    },
    /** 截取标签 **/
    tagScreenshot(dom) {
      return new Promise((resolve, reject) => {
        // let dom = document.getElementById("tag-image");
        //   setTimeout(() => {
        //     html2canvas(dom, {
        //       allowTaint: true,
        //       useCORS: true
        //     })
        //       .then(canvas => {
        //         resolve(canvas.toDataURL("image/png", 1));
        //       })
        //       .catch(reject());
        //   });
        // });
        domtoimage.toPng(dom).then((dataUrl) => {
          resolve(dataUrl)
        })
        // return html2canvas(dom, {
        //   allowTaint: true,
        //   useCORS: true
        // }).then(canvas => {
        //   return canvas.toDataURL("image/png", 1);
        // });
      })
    },
    async derivePdf() {
      this.showLoading = true
      const template_name = this.template_list
        .filter((v) => {
          return v.id === this.active_template_id
        })[0]
        .name?.replace(/\+/g, '_')
      let pdfLabelName = []
      if (this.ncSetting.pdf_label_name) {
        const getUniqueJoined = (getValue) => {
          const values = this.$store.state.preLayoutData
            .map((item) => getValue(item))
            .map((v) => String(v ?? '').trim())
            .filter((v) => v !== '')
          return [...new Set(values)].join(',')
        }
        for (const item of this.ncSetting.pdf_label_name) {
          if (item === 'firstFolder') {
            const firstFolder = await genFirstLevelFileName(true)
            pdfLabelName.push(firstFolder.firstLevelFileName)
            continue
          }
          switch (item) {
            case 'address':
              let address = getUniqueJoined((v) => v.address)
              if (address) pdfLabelName.push(address)
              break
            case 'orderNo':
              let orderNo = getUniqueJoined((v) => v.orderNo)
              if (orderNo) pdfLabelName.push(orderNo)
              break
            case 'customerName':
              let customerName = getUniqueJoined((v) => v.customer_name)
              if (customerName) pdfLabelName.push(customerName)
              break
          }
        }
      }
      /** pdf文件名 */
      let name = pdfLabelName.length
        ? pdfLabelName.join(this.ncSetting.pdf_label_name_separator || '_')
        : template_name

      if (!this.isNewTagDraw) {
        await jsPdfTool.loadFontByTagTemp([
          ...(this.cur_template.tem_data ?? []),
          ...(this.cur_template.surplus_data ?? []),
          ...(this.cur_template.sub_tem_data ?? []),
        ])
        // svg直转 pdf
        const binary = await getSvgListToPdfJSBinary(this.tag_svg_list, {
          unit: 'mm',
          format: [this.cur_template.tag_width, this.cur_template.tag_height],
        })

        FileSaver.saveAs(new Blob([binary]), `${name}.pdf`)
        this.isPrintFlag = false
        this.showLoading = false
        this.export_loading = false
        this.export_loading_text = translate('common.exportPic')
        // 开启了发送至彩标
        if (this.$store.state.preferencesSetting.setting?.isSendToEzSort) {
          transformToEzSort.setIsForceNotUseAutoWrite(true)
          await transformToEzSort.processDownloadOpenEzsort(name)
        }
      } else {
        // 新版标签生成
        const data = this.selectViewData(
          window.$copy(
            this.currentBigpart
              ? [this.currentBigpart]
              : this.paibanData && this.paibanData.length
              ? this.paibanData
              : defaultPaibanData
          )
        )
        /** 批量补标签的板件 uniqueId 数组 */
        const batchTaggingIds = this.batchTaggingList.map(
          (item) => item.partUniqueId
        )
        data.forEach((plank) => {
          const parts = plank.parts
          /** 判断板件是否存在批量补标签的板件 */
          parts.forEach((p) => {
            if (batchTaggingIds.includes(p.partUniqueId)) {
              p.isBatchTagging = true
              plank.isBatchTagging = true
            }
          })
        })
        const templateData = {
          data: JSON.stringify({
            ...(this.cur_template ?? {}),
            roomNameMap: deepMapsToPlain(this.roomNameMap),
          }),
          name:
            this.template_list.filter((v) => {
              return v.id === this.active_template_id
            })[0]?.name ?? '默认模板',
          id: this.active_template_id,
        }

        const tagSetting = {
          isGenPartTag: this.gen_small_plank_tag,
          isGenPartTagS: this.gen_small_plank_tag_surplus,
          isGenSurplusTag: this.cut_need_lave,
          isGenSurplusTagS: this.cut_need_lave_surplus,
          isGenRestTag: this.need_lave,
          isGenRestTagS: this.need_lave_surplus,
          isGenRestTagEnd: this.is_lave_tag_end,
          isGenRestTagEndS: this.is_lave_tag_end_sur,
          isGenBigPartTag: this.gen_big_plank_tag,
          isGenBigPartTagS: this.gen_big_plank_surplus_tag,
          isGenNoCutTag: this.gen_no_cut_tag,
          positionX: this.print_setting.x,
          positionY: this.print_setting.y,
          isGenBigPartFileSuffix: this.isGenNcSuffix,
          isTagMirror: this.jx_checked,
          isGenFiveSixDir: this.five_six_dir,
          isGenColorful: this.print_color_tag,
          tagOrder: this.sort_value,
          opacity: this.print_setting.opacity,
          size: this.print_setting.size,
          sizeAuto: this.print_setting.sizeAuto,
          isReverseColor: this.gen_part_color_revert,
          roomCabinetPanelNameDisplay: this.roomCabinetPanelNameDisplay,
          dualLanguageTags: this.dualLanguageTags,
        }

        await generateTagFile(
          data,
          templateData,
          this.$store,
          {
            isTag: false,
            isPdf: true,
          },
          {},
          null,
          {
            isNewGen: true,
            tagSetting: tagSetting,
            fileName: name,
            callBackFunc: async (tagData) => {
              this.showLoading = false
              // if (typeof tagData === 'string') {
              //   this.isTagLoading = false
              //   this.cut_progress = 100
              //   this.isCanDownLoading = false
              //   this.pdfSrc = tagData
              //   // 移除 data URI 前缀（如果有）
              //   const base64 = tagData.replace(
              //     /^data:application\/pdf;base64,/,
              //     ''
              //   )

              //   // 解码 base64 为字节数组
              //   const byteCharacters = atob(base64)
              //   const byteNumbers = new Array(byteCharacters.length)
              //   for (let i = 0; i < byteCharacters.length; i++) {
              //     byteNumbers[i] = byteCharacters.charCodeAt(i)
              //   }

              //   const byteArray = new Uint8Array(byteNumbers)
              //   const blob = new Blob([byteArray], { type: 'application/pdf' })
              //   FileSaver.saveAs(blob, `${template_name}.pdf`)
              //   this.isPrintFlag = false
              //   this.showLoading = false
              //   this.export_loading = false
              //   this.export_loading_text = translate('common.exportPic')
              //   // 开启了发送至彩标
              //   if (
              //     this.$store.state.preferencesSetting.setting?.isSendToEzSort
              //   ) {
              //     transformToEzSort.setIsForceNotUseAutoWrite(true)
              //     await transformToEzSort.processDownloadOpenEzsort(
              //       template_name
              //     )
              //   }
              //   // callBack && callBack(pdfSrc.value)
              // } else {
              //   let arrPI = getDeviceXDPI()
              //   const width = mmToPx(this.cur_template?.tag_width ?? 0, arrPI)
              //   const height = mmToPx(this.cur_template?.tag_height ?? 0, arrPI)
              //   this.tagSize.height = height
              //   this.tagSize.width = width
              //   this.tagList.push(...tagData.data)
              //   if (tagData.isFinished) {
              //     this.isTagLoading = false
              //     this.cut_progress = 100
              //     this.isCanDownLoading = false
              //   }
              // }
            },
          }
        )
      }
    },
    resetGenBigTag() {
      this.gen_big_plank_tag = false
    },
    resetLavePart(keepLaveStatus) {
      if (!keepLaveStatus) {
        this.need_lave = false
      }
      this.isLoadLavePart = false
      this.lavePage = 1
      this.lave_svg_list = []
    },
    // 重置缓存
    resetCache() {
      this.cacheTagList = {}
    },
    // 重置数据
    async resetRequest() {
      // 将分类数据传入筛选数组
      // 初始化可筛选数据
      this.select_options = [{ label: translate('common.all'), value: 'all' }]
      const paibanData = JSON.parse(
        JSON.stringify(this.$store.state.paibanData)
      )
      let onePart = this.currentBigpart

      let data = onePart ? [onePart] : paibanData
      data.forEach((item) => {
        if (item.stockKey) {
          const stockKey = item.stockKey.split(':').slice(0, 3).join(':')
          const f = this.select_options.find((it) => it.value === stockKey)
          if (!f) {
            this.select_options.push({ label: stockKey, value: stockKey })
          }
        }
      })
      // await this.getPreferencesSetting(undefined, this.userInfo.platform)
      // if (this.$store.state.ncSetting.labelFormat === 'jingmei')
      await this.getFileSetting()
      // this.print_setting = { cols: 1, col_space: 0 }
      // this.sort_value = 1
      this.resetLavePart(true)
      this.resetCache()
      // this.resetGenBigTag()
      // this.jx_checked = false
      // this.five_six_dir = false
      this.initData()
      this.initLaveData()
      this.tagListSourceData = []
      this.laveTagListSourceData = []
      this.getTemplateList()
      getSpecialRemarks().then((res) => {
        if (res.status === 200) {
          this.$store.commit('setSpecialRemarks', res?.data?.data ?? {})
        }
      })
    },

    // 加载标签了列表
    async _loadTagList(isRefresh, isLoadAll) {
      this.executeId = nanoid()
      const executeId = this.executeId
      this.isLoadWaitting = false
      /** 是否已经是一个新的执行，如果是则弹出,在异步之后都进行判断 */
      const isRepect = (id) => {
        if (id !== this.executeId) {
          this.isTagLoading = false
          return true
        }
      }
      // 当是标签时
      this.judgeExistCustSpecTag([
        ...(this.cur_template?.tem_data ?? []),
        ...(this.cur_template?.sub_tem_data ?? []),
      ])
      // 获取最新的ncSetting 直接进入标签管理是没有process_setting_id的，后端会报错
      // 需要进行判断
      if (this.$store.state.ncSetting?.process_setting_id) {
        let ncParams = {
          setting_id: this.$store.state.ncSetting.process_setting_id,
        }
        let newNcSetting = await fetchGetProductionNcSetting(ncParams)
        if (newNcSetting.status !== -1) {
          newNcSetting = newNcSetting?.data ?? {}
          // 更新store里面的nc设置
          this.$store.commit('setNcSetting', {
            ...this.$store.state.ncSetting,
            ...newNcSetting,
          })
        }
      }
      if (isRepect(executeId)) {
        return
      }
      if (!this.isNewTagDraw) {
        const preTemp = this.cur_template
        if (isRefresh) {
          this.isNoMoreTag = false
          this.isTagLoading = false
          this.page = 1
          this.tag_svg_list = []

          this.resetLavePart(true)
        }
        //如果没有勾选生成裁剪板件标签过滤掉supplus标签
        this.tagListSourceData = this.tagListSourceData.filter((i) => {
          const isSupplus = i.currentPlank?.specialType === 'supplus'
          const hasSurplus =
            i.plank?.surplusInfo && !i.plank?.surplusInfo?.other_plate

          if (isSupplus) {
            return (
              (this.cut_need_lave && !hasSurplus) ||
              (this.cut_need_lave_surplus && hasSurplus)
            )
          }
          return true
        })
        if (this.isNoMoreTag || this.isTagLoading) {
          return
        }

        // 加载期间不可下载文件
        this.isCanDownLoading = true
        let start = (this.page - 1) * this.limit
        let end = this.page * this.limit
        // 如果是余料标签
        if (this.isLoadLavePart) {
          start =
            this.tagListSourceData.length + (this.lavePage - 1) * this.limit
          end = this.tagListSourceData.length + this.lavePage * this.limit
        }
        let total = this.renderDataList.length
        if (isLoadAll) {
          // 当需要下载全部的时候,重置start和end
          start = this.tag_svg_list.length
          end = total
        }
        const isTemp = this.$route.query.from ? true : false
        this.isTagLoading = true
        let arr = []
        this.listDomWrap = document.querySelector('.tag_canvas_wap')
        if (this.listDomWrap) this.scrollTop = this.listDomWrap.scrollTop

        await this.timer(50)
        if (isRepect(executeId)) {
          return
        }
        // 获取板件是否需要逆时针旋转
        let isRotatePlank = false
        const typographyKlass = this.cur_template?.tem_data.find(
          (it) => it.type === 'Typography'
        )
        this.trimSide = this.isHistoryStatus
          ? window.sessionStorage.getItem('trimSide')
          : this.$store.state.ncSetting.trimSide
        if (typographyKlass) {
          isRotatePlank = typographyKlass.data.plankRotate
        }

        // 对roomNameMap进行深拷贝，因为在生成标签过程中要对该值进行删除，为了不影响原始值，同时为了性能，因此在循环外进行此操作
        let copyRoomNameMap = null
        if (this.roomNameMap) {
          copyRoomNameMap = cloneDeep(this.roomNameMap)
        }
        //这里能拿到模板数据，获取当前模板同尺寸小板标签的数据
        const statisticsCount = countSameSizeBoard(
          this.renderDataList.filter((item) => item.type === 'tag')
        )
        // 彩色标签数据源判断逻辑
        // 订单 房间 柜体 任何一个数据源超过12个，则toast提示彩色标签不生效
        let judgeLimit = this.handleJudgeLimit('tag')
        // 获取所有余料 余料标签所在余料库使用
        const surRes = await getSurplusList({ page: 1, limit: 999 })
        if (isRepect(executeId)) {
          return
        }
        this.allSurplusList = surRes.status ? surRes.data.data : []
        // 开始生成大板及余料标签前 将结果置为空
        this.bigplantLableList = {}
        this.LaveTagBase64List = {}
        // 获取骨骼门基板（标签只生成基板标签，不生成小条子及合并板件标签）
        function getFrameDoorBasePart(part) {
          if (!judgeIsMergeFrameDoor(part)) {
            return part
          }
          const basePart = part.frame_door_children.find(
            (child) => child && child.plankType === 'SingleDoor'
          )
          return basePart || part.frame_door_children[0] || part
        }
        for (let i = start; i < end; i++) {
          // 因为异步的原因 可能同时存在多个执行 异步会错误的关闭加载框
          this.isTagLoading = true
          if (!this.isInCurrentRoute) {
            this.isTagLoading = false
            this.isCanDownLoading = false
            return
          }
          // 修改进度
          this.cut_progress = parseInt((100 / end) * (i + 1) + 0.001)
          // 进度完成才可下载
          if (this.cut_progress >= 100) {
            this.isCanDownLoading = false
          }
          let svg_html
          const current = this.renderDataList[i]
          const baseRenderPart = getFrameDoorBasePart(current?.part)
          if (!current) {
            break
          }
          // 当有批量补标签数据时 有批量标志的板才进行绘制 从而保证页码和大板数和整个打印保持一致
          const isPartTag = isPartTagType(current.type)
          let isDrawTag = isPartTag
          let isDrawPlank = current.type === 'plank'
          let isDrawLaveTag = !isPartTag && current.type !== 'plank'
          if (this.batchTaggingList.length) {
            isDrawTag = isPartTag && current.part.isBatchTagging
            isDrawPlank =
              current.type === 'plank' &&
              current.plank.parts.some((item) => item.isBatchTagging)
            isDrawLaveTag =
              !isPartTag &&
              current.type !== 'plank' &&
              current.plank.parts.some((item) => item.isBatchTagging)
          }
          if (isDrawTag) {
            // 生成标签大板尺寸
            const { size } = getGraghEdge(current.plank)
            current.plank.plankSize = size

            let gen_part_color_revert = this.gen_part_color_revert
            // 应急码设置了特殊标记 并且有特殊标记时 才生效标签反色
            if (
              this.ncSetting?.emergence_setting_key?.includes('specialMark')
            ) {
              let specialMark =
                current.part.specialFlag ?? current.part.specTagTemplate
              gen_part_color_revert =
                specialMark && specialMark !== 'default'
                  ? gen_part_color_revert
                  : false
            }
            const isSubTag = current.type === 'subTag'
            const drawTemplate = getTagDrawTemplate(this.cur_template, isSubTag)
            const subTypography = drawTemplate?.tem_data?.find(
              (it) => it.type === 'Typography'
            )
            const tagRotatePlank = isSubTag
              ? Boolean(subTypography?.data?.plankRotate)
              : isRotatePlank
            // 要将模板转换成原始模板 需要拿到翻译文件
            await escapeTemplate(drawTemplate)
            const prevCollectLen = this.collect?.length ?? 0
            svg_html = await createTag(
              {
                ...drawTemplate,
                roomNameMap: copyRoomNameMap,
                print_color_tag: this.print_color_tag,
                judgeLimit,
                statisticsCount,
                allSurplusList: this.allSurplusList,
                gen_part_color_revert,
              },
              current.plank,
              baseRenderPart,
              current.plank_index,
              current.part_index,
              this.all_page,
              this.jx_checked,
              this.five_six_dir,
              {
                scale: this.canvas_scale,
                trimSide: this.trimSide,
              },
              this.$store.state.ncSetting,
              // newNcSetting,
              current.currentPlank,
              this.collect,
              this.sort_value,
              isTemp,
              this.cut_need_lave || this.cut_need_lave_surplus,
              tagRotatePlank,
              i,
              { genTagWay: 'preview' }
            )
            if (isRepect(executeId)) {
              return
            }
            if (isSubTag && isBlankTagSvg(svg_html)) {
              if ((this.collect?.length ?? 0) > prevCollectLen) {
                this.collect.length = prevCollectLen
              }
              current.skipRender = true
              svg_html = ''
            }
          } else if (isDrawPlank) {
            await escapeTemplate(bigPlankTemp)
            // 大板标签
            svg_html = await createTag(
              {
                ...bigPlankTemp,
                tag_width: this.cur_template.tag_width,
                tag_height: this.cur_template.tag_height,
              },
              {
                ...current.plank,
                isGenNcSuffix: this.isGenNcSuffix,
              },
              baseRenderPart, // current.part
              current.plank_index,
              null, // current.part_index
              this.all_page,
              this.jx_checked, // this.jx_checked
              false, // this.five_six_dir
              { scale: this.canvas_scale, trimSide: this.trimSide },
              this.$store.state.ncSetting,
              // newNcSetting,
              current.currentPlank,
              this.collect,
              this.sort_value,
              isTemp,
              false,
              isRotatePlank,
              i,
              { genTagWay: 'preview' }
            )
            if (isRepect(executeId)) {
              return
            }
            const base64 = this.svgToBase64(svg_html)
            if (!this.bigplantLableList[current.plank_index]) {
              this.bigplantLableList[current.plank_index] = base64
            }
          } else if (isDrawLaveTag) {
            await escapeTemplate(this.cur_template)
            // 当是余料标签时
            svg_html = await createLaveTag(
              this.cur_template,
              current.plank,
              current.plank_index,
              { scale: this.canvas_scale },
              this.$store.state.ncSetting,
              // newNcSetting,
              this.collect,
              isRotatePlank,
              this.all_page,
              this.part_page,
              i
            )
            if (isRepect(executeId)) {
              return
            }
            this.lave_svg_list.push(svg_html)
            const base64 = this.svgToBase64(svg_html)
            if (!this.LaveTagBase64List[current.plank_index]) {
              this.LaveTagBase64List[current.plank_index] = base64
            }
          }
          // 这儿应对生成大板标签选择的情况
          if (isRepect(executeId)) {
            return
          }
          if (!this.isSameTemp(preTemp)) {
            this.isTagLoading = false
            return
          }
          if (isLoadAll) {
            // 避免在生成标签的时候切换生成余料标签
            if (this.need_lave || this.need_lave_surplus) {
              end = this.renderDataList.length
            } else {
              if (i >= this.renderDataList.length) {
                // 此时表明标签已经生成完毕
                break
              } else {
                end = this.renderDataList.length
              }
            }
          }
          if (svg_html) {
            arr.push(svg_html)
            this.tag_svg_list.push(svg_html)
          }
        }
        if (end >= total) {
          this.isNoMoreTag = true
        }

        // this.renderTag && this.renderTag.clear()
        if (!this.isSameTemp(preTemp)) {
          // this.listDomWrap.removeEventListener('scroll', this.keepScrollTop)
          this.isTagLoading = false
          return
        }
        // this.tag_svg_list.push(...arr)
        setTimeout(() => {
          // 这个是为了避免列表加载完毕以后的继续滚动
          // this.listDomWrap.removeEventListener('scroll', this.keepScrollTop)
          this.judgeLoadContinue(preTemp)
        }, 500)
        this.isTagLoading = false
        bus.$emit('waitGenAll')
        // 如果是全部下载
        if (isLoadAll) {
          // 修改page、lavePage值
          this.page = Math.ceil(this.tagListSourceData.length / this.limit)
          if (this.need_lave || this.need_lave_surplus) {
            this.lavePage = Math.ceil(
              this.laveTagListSourceData.length / this.limit
            )
          }
          return
        }
        if (this.isLoadLavePart) {
          this.lavePage++
        } else {
          this.page++
        }
      } else {
        const data = this.selectViewData(
          window.$copy(
            this.currentBigpart
              ? [this.currentBigpart]
              : this.paibanData && this.paibanData.length
              ? this.paibanData
              : defaultPaibanData
          )
        )
        const templateData = {
          data: JSON.stringify({
            ...(this.cur_template ?? {}),
            roomNameMap: deepMapsToPlain(this.roomNameMap),
          }),
          name:
            this.template_list.filter((v) => {
              return v.id === this.active_template_id
            })[0]?.name ?? '默认模板',
          id: this.active_template_id,
        }

        const tagSetting = {
          isGenPartTag: this.gen_small_plank_tag,
          isGenPartTagS: this.gen_small_plank_tag_surplus,
          isGenSurplusTag: this.cut_need_lave,
          isGenSurplusTagS: this.cut_need_lave_surplus,
          isGenNoCutTag: this.gen_no_cut_tag,
          isGenRestTag: this.need_lave,
          isGenRestTagS: this.need_lave_surplus,
          isGenRestTagEnd: this.is_lave_tag_end,
          isGenRestTagEndS: this.is_lave_tag_end_sur,
          isGenBigPartTag: this.gen_big_plank_tag,
          isGenBigPartTagS: this.gen_big_plank_surplus_tag,
          positionX: this.print_setting.x,
          positionY: this.print_setting.y,
          isGenBigPartFileSuffix: this.isGenNcSuffix,
          isTagMirror: this.jx_checked,
          isGenFiveSixDir: this.five_six_dir,
          isGenColorful: this.print_color_tag,
          tagOrder: this.sort_value,
          opacity: this.print_setting.opacity,
          size: this.print_setting.size,
          sizeAuto: this.print_setting.sizeAuto,
          isReverseColor: this.gen_part_color_revert,
          roomCabinetPanelNameDisplay: this.roomCabinetPanelNameDisplay,
          dualLanguageTags: this.dualLanguageTags,
        }
        if (
          (this.isCanDownLoading || this.isTagLoading) &&
          this.active_template_id == this.isLoaddingTempId &&
          this.oriTagSetting == JSON.stringify(tagSetting)
        ) {
          return
        } else {
          this.isLoaddingTempId = this.active_template_id
          this.oriTagSetting = JSON.stringify(tagSetting)
          // 加载期间不可下载文件
          this.isCanDownLoading = true
          this.isTagLoading = true
        }

        this.dealDataForFiveSixDir(data)
        this.tagList = []

        await generateTagFile(
          data,
          templateData,
          this.$store,
          {
            isTag: true,
          },
          {},
          null,
          {
            isNewGen: true,
            tagSetting: tagSetting,
            callBackFunc: (tagData) => {
              if (typeof tagData === 'string') {
                this.pdfSrc = tagData
                this.isTagLoading = false
                this.cut_progress = 100
                this.isCanDownLoading = false
                // callBack && callBack(pdfSrc.value)
              } else {
                let arrPI = getDeviceXDPI()
                const width = mmToPx(this.cur_template?.tag_width ?? 0, arrPI)
                const height = mmToPx(this.cur_template?.tag_height ?? 0, arrPI)
                this.tagSize.height = height
                this.tagSize.width = width
                const tagIndex = tagData.index
                if (!tagIndex) {
                  this.tagList = []
                }
                this.tagList.push(...tagData.data)
                const step = (1 / data.length) * 100
                if (this.cut_progress + step > 100) {
                  this.cut_progress = 100
                } else {
                  const re = this.cut_progress + step
                  this.cut_progress = re > 100 ? 100 : re
                }
                if (tagData.isFinished) {
                  this.isTagLoading = false
                  this.isCanDownLoading = false
                  this.isLoaddingTempId = -2
                }
              }
            },
          }
        )
        this.isNoMoreTag = true
      }
    },
    // 处理五六面钻放板基准位置
    dealDataForFiveSixDir(data) {
      data.forEach((plank) => {
        const resPlank = this.source_data.find(
          (sp) => sp.stockKey == plank.stockKey
        )
        if (resPlank) {
          plank.parts = resPlank.parts
        }
      })
    },

    /**
     * 判断是标签模板中是否存在自定义特殊标签
     * @params {Array<Objiect>} tem_data 标签模板元素数组
     * */
    judgeExistCustSpecTag(tem_data) {
      this.$store.commit('setIsExistcusSpecialTag', false)
      ;(tem_data || []).forEach((item) => {
        if (item.type === 'specialMark') {
          this.$store.commit('setIsExistcusSpecialTag', true)
        }
      })
    },
    svgToBase64(svgString) {
      return `data:image/svg+xml;charset=utf-8,${encodeURI(svgString)}`
    },
    isSameTemp(temp) {
      return JSON.stringify(temp) === JSON.stringify(this.cur_template)
    },
    keepScrollTop() {
      if (this.listDomWrap) {
        this.listDomWrap.scrollTop = this.scrollTop
      }
    },
    // 是否需要继续加载
    judgeLoadContinue(pre_template) {
      let wrap = document.querySelector('.tag_canvas_wap')
      let tagList = document.querySelector('.tag_list')
      if (pre_template && !this.isSameTemp(pre_template)) {
        return
      }
      if (
        tagList &&
        wrap &&
        wrap.offsetHeight > tagList.offsetHeight &&
        !this.isNoMoreTag
      ) {
        this.loadTagList()
        return
      }
    },
    // 筛选数据
    selectViewData(data) {
      if (this.cut_select_value && this.cut_select_value !== 'all') {
        let finalData = data.filter((item) => {
          const stockKey = item.stockKey.split(':').slice(0, 3).join(':')
          return stockKey === this.cut_select_value
        })
        return finalData
      }
      return data
    },

    handleColsChange() {
      this.saveConf()
      buryPointApi('tag', 'one_to_more')
    },
    handleColSpaceChange() {
      this.saveConf()
      buryPointApi('tag', 'tag_space')
    },
    handleConfigSlider(type) {
      if (type == 'opacity') {
        buryPointApi('tag', 'special_mark_opacity')
      } else if (type == 'sizeAuto') {
        buryPointApi('tag', 'tag_auto_size')
      }
      clearTimeout(timer)
      timer = setTimeout(() => {
        this.isreloading = true
        this.saveConf()
        this.isPaibanDataChange = true
        this.resetRequest()
      }, 300)
    },
    // 调用保存
    saveMaterialPaiban(url, auto_save) {
      const highgloss_direction = this.getHighgloss_direction
      let plankList = null
      let process_setting = null
      if (this.bigPartsInfo.length > 0) {
        plankList = this.bigPartsInfo
        process_setting = this.ncSetting
      }
      let addressArr = []
      this.$store.state.preLayoutData.forEach((part) => {
        const str = part.groupNo ?? part.address
        if (!addressArr.includes(str)) {
          addressArr.push(str)
        }
      })
      if (window.webToQt) {
        this.paibanWayName = `${addressArr.join('+')}_WebBluen_生产线(${
          this.ncSetting?.process_setting_name ?? ''
        })`
      } else {
        this.paibanWayName = `${addressArr.join('+')}_FromWebPage_生产线(${
          this.ncSetting?.process_setting_name ?? ''
        })`
      }
      const fileName = `filterObj_${new Date().getTime()}`
      const path = 'cloud_paiban/filterObj'
      const currentLine = this.proLineList.find(
        (item) => item.id === process_setting?.process_setting_id
      )?.data
      saveDataToOSS(this.filterObject, fileName, path).then((res) => {
        const obj = {
          name: this.paibanWayName,
          plank_info: {
            plankTypeList: plankList,
            historyUrl: url,
            used_rate: this.paibanExtraInfo.total_used_rate
              ? this.paibanExtraInfo.total_used_rate
              : '',
            process_setting_name: process_setting
              ? process_setting.process_setting_name
              : '', // 记录生产线名字, 判断是否为默认生产线
            order_codes: this.orderInfo.order_codes
              ? this.orderInfo.order_codes
              : '',

            filterObj: res,
            highgloss_direction,
            batch: this.orderInfo.batch
              ? Object.keys(this.orderInfo.batch).every((key) => {
                  return this.orderInfo.batch[key] > 0
                })
              : false,
            mixPaibanPlans:
              this.$store.state.materialListStore?.selectedMixPaibanPlans ?? [],
            is_des_material_no_cut: currentLine?.is_des_material_no_cut,
            material_keywords_list: currentLine?.material_keywords_list,
          },
          process_setting_id: process_setting
            ? process_setting.process_setting_id
            : -1,
          order_list: this.orderInfo.order_ids
            ? this.orderInfo.order_ids.split(',').map(Number)
            : [],
          file_type: this.paibanData.length ? 'paiban' : 'material',
          save_node: 3,
          generate_batch: this.orderInfo.batch
            ? Object.keys(this.orderInfo.batch).every((key) => {
                return this.orderInfo.batch[key] > 0
              })
            : false,
          trimSide: this.trimSide,
          generate_batch_num: this.$store.state.typesettingBatch,
        }
        if (
          this.orderInfo.needPaibanRoomIds &&
          this.orderInfo.needPaibanRoomIds.length > 0
        ) {
          obj.room_ids = this.orderInfo.needPaibanRoomIds
        }
        if (auto_save) {
          obj.auto_save = auto_save
        }
        if (this.isHistoryStatus) {
          obj.plank_info.used_rate = this.historyOrder.plank_info.used_rate
        }
        obj.plank_info.hasSpecialBigPlank = this.paibanData.some((plank) =>
          isSpecialBigPlank(plank)
        )
        obj.plank_info.hasSurplusBigPlank = this.paibanData.some((plank) =>
          isSurplusBigPlank(plank)
        )
        this.$token('/save_material_data', obj, () => ({}))
      })
    },
    autoSaveHistory() {
      const { obj } = this.ossFilesParams
      if (this.paibanData && this.paibanData.length) {
        ossUploadFiles(obj, (url) => {
          this.saveMaterialPaiban(url, 1)
        })
      }
    },
    // 鼠标监听事件
    handleShowTip() {
      let colorPop = document.getElementById('printTag2-color-pop')
      colorPop.style.display = 'block'
      colorPop.addEventListener('mouseover', this.handleShowTip)
      colorPop.addEventListener('mouseout', this.handleCloseTip)
    },
    handleCloseTip() {
      let colorPop = document.getElementById('printTag2-color-pop')
      colorPop.style.display = 'none'
    },
    // 判断彩色标签是否符合标准
    handleJudgeLimit(type) {
      let judgeLimit =
        this.$store.state.limitOvers.length && this.print_color_tag
      if (judgeLimit && type == 'tag') {
        this.$message.warning(
          `${this.translateLang('common.exist')}${this.$store.state.limitOvers
            .map((item) =>
              item == 'orderNo'
                ? this.translateLang('common.order')
                : item == 'roomName'
                ? this.translateLang('common.roomName')
                : this.translateLang('common.loc')
            )
            .join('/')}${this.translateLang('common.limitNotEffect')}`
        )
      }
      return judgeLimit
    },
    updatePreference({ data, isErr }) {
      if (isErr) return
      data = data || this.$store.state.preferencesSetting.setting
      // const data = res.data
      // 更新store模块中的偏好设置，后续需要使用store中的偏好设置替换页面中的使用方法
      // this.$store.commit('preferencesSetting/setSetting', data)
      // labelTemplate 模版
      // this.active_template_id = data.labelTemplate
      // surplusLabel 生成余料标签
      this.need_lave = data.surplusLabel
      this.need_lave_surplus = data.surplusLabelForSur ?? data.surplusLabel
      this.is_lave_tag_end = data.cutLaveEnd ?? false
      this.is_lave_tag_end_sur = data.cutLaveEndForSur ?? data.cutLaveEnd

      // bigPlankLabel 生成大板信息标签
      this.gen_big_plank_tag = data.bigPlankLabel
      this.gen_big_plank_surplus_tag =
        data.bigPlankLabelForSur ?? data.bigPlankLabel
      // gen_small_plank_tag 生成小板信息标签
      this.gen_small_plank_tag = data.genSmallPlankLabel ?? true
      this.gen_small_plank_tag_surplus =
        data.genSmallPlankLoaelForSurplus ?? data.genSmallPlankLabel ?? true
      this.gen_no_cut_tag = data.genNoCutTag ?? false
      // isGenNcSuffix 大板标签生成下料文件名后缀
      this.isGenNcSuffix = data.isGenNcSuffix
      // labelCoord 大板标签贴标坐标
      this.xCoordinate = data.labelCoord?.X ?? 0
      this.yCoordinate = data.labelCoord?.Y ?? 0

      // mirrorLabel 	标签镜像
      this.jx_checked = data.mirrorLabel
      // // boardBenchmark 生成五六面钻放板基准标识
      this.five_six_dir = data.boardBenchmark
      // labelSortWay 标签排序适应自动上下料
      this.sort_value = data.labelSortWay == 'default' ? 1 : data.labelSortWay
      //   printColorTag 生成彩色标签 默认不开启
      this.print_color_tag = data.printColorTag ?? false
      // genPartColorRevert 生成小板反色标签 默认不开启
      this.gen_part_color_revert = data.genPartColorRevert ?? false
      // roomCabinetPanelNameDisplay 房间柜体面板名称显示
      this.roomCabinetPanelNameDisplay =
        data.roomCabinetPanelNameDisplay ?? false
      // dualLanguageTags 双语标签用户设置此字段需要翻译
      this.dualLanguageTags = data.dualLanguageTags
      // labelColumnNum 标签列数
      this.print_setting.cols = data.labelColumnNum
      // labelColumnGap 多列标签列间距
      this.print_setting.labelColumnGap = data.labelColumnGap
      // 特殊标记透明度
      this.print_setting.opacity = data.opacity ?? 0.24
      // 特殊标记大小
      this.print_setting.size = data.size ?? 1
      // 特殊标记大小自适应开/关状态
      this.print_setting.sizeAuto = data.sizeAuto ?? true //默认开启
      this.cut_need_lave = data.cutNeedLave
      this.cut_need_lave_surplus = data.cutNeedLaveForSur ?? data.cutNeedLave
      // 是否开启发送至彩标
      this.isSendToEzSort = data.isSendToEzSort
      // TODO标记
      this.setDrawOpacity(this.print_setting.opacity)
      this.setDrawSize(this.print_setting.size)
      this.setDrawSizeAuto(this.print_setting.sizeAuto)
    },
    /** @description 加载所需字体，统一加载 微软雅黑/宋体/黑体， 只会执行一次，字体加载完成后内部代码不会再响应 */
    async addFont() {
      this.isLoadFont = true
      await initFabricNeedFont()
      await initGuiguiTranslate()
      this.isLoadFont = false
    },
    changeTagTabs(activeKey) {
      this.activeTagKey = activeKey
    },
    /** 修改发送至彩标状态 */
    handleChangeToEzSort() {
      this.saveConf()
      if (this.isSendToEzSort) {
        buryPointApi('layout', 'sendToEzSort')
      }
    },
    /** 切换导出语言 */
    // 切换标签上的导出语言
    async handleChangeExportLanguage() {
      // 更新store里面的标签语言
      this.$store.commit('setExportLanguage', this.exportLanguage)
      // 更新store里面的翻译表
      this.updateLocalLanguage()
      // 重新渲染绘制标签
      this.cut_progress = 0
      this.startRender()
      // 记录埋点
      buryPointApi('tag', 'export_language')
    },
    async updateLocalLanguage() {
      const language = languageMap.get(this.$store.state.exportLanguage ?? 'zh')
      // 获取语言模板
      const templateMap = this.$store.state.templateMap ?? new Map()
      // 如果已经存储了数据表或者当前选择的语言是中文
      if (templateMap?.has(language) || language === 'zh') {
        return
      }
      try {
        if (!language) return
        await getLabelTranslation({ language }).then((res) => {
          this.$store.commit(
            'setTemplateMap',
            templateMap.set(language, {
              ...res.data,
              ...additionalTranslateMap.get(language),
            })
          )
        })
      } catch (err) {
        console.log(err, 'err')
        this.$store.commit(
          'setTemplateMap',
          templateMap.set(language, additionalTranslateMap.get(language))
        )
      }
    },
    updateTemplate() {
      // 跟随系统翻译语言环境
      let currentLang = this.$store.state.exportLanguage ?? Lang.state.lang
      this.exportLanguage = currentLang
      this.handleChangeExportLanguage()
    },

    async getBatch() {
      const res = await getPaibanBatch()
      this.$store.commit('setTypesettingBatch', res.data.layout_batch)
    },
    async checkIsExport(isShowModal = true) {
      const { room_cabinet_panel_name_display } =
        this.$store.state.userPermissions
      if (
        this.roomCabinetPanelNameDisplay &&
        !room_cabinet_panel_name_display &&
        !this.isOverseas
      ) {
        if (isShowModal) {
          await showSyncModal({
            modalComponent: GBaseModal,
            title: translateLang('注意'),
            contain: translateLang(
              '您暂无中英双语标签生成权限，当前仅可预览；如需正式使用，请联系销售开通~'
            ),
            okText: translateLang('确认'),
            isShowCancelBtn: false,
          })
        }
        return false
      }
      return true
    },
  },
  computed: {
    ...mapState([
      'isSubPrintTag',
      'historyOrder',
      'userInfo',
      'isHistoryStatus',
      'historyPlankEdgeOff',
      'batchTaggingList',
      'proLineList',
      'highgloss_direction',
    ]),
    ...mapState(plankMapState),
    isOverseas() {
      return !!this.$store.state.userInfo.is_global
    },
    getHighgloss_direction() {
      let highgloss_direction
      if (this.isHistoryStatus) {
        highgloss_direction = this.historyOrder.plank_info.highgloss_direction
          ? this.historyOrder.plank_info.highgloss_direction
          : 'back'
      } else {
        highgloss_direction = this.highgloss_direction
      }
      return highgloss_direction
    },
    ossFilesParams() {
      const currentLine = this.proLineList.find(
        (item) => item.id === this.ncSetting.process_setting_id
      )
      let obj = {
        layoutData: this.preLayoutData,
        paibanData: [],
        recodeSelectPart: this.recodeSelectPart,
        recodeSelectSurplus: this.recodeSelectSurplus,
        thinkerxMaterialKeys: this.$store.state.thinkerxMaterialKeys,
        paibanInfo: {
          historyPlankEdgeOff: this.historyPlankEdgeOff,
          historySecondTrimValue: this.ncSetting?.secondTrimValue,
          batchTaggingList: this.batchTaggingList,
          is_des_material_no_cut:
            currentLine?.data?.is_des_material_no_cut ?? false,
          material_keywords_list:
            currentLine?.data?.material_keywords_list ?? [],
        },
        filterPlankList:
          this.beforeSearchMaterialList ??
          this.beforeSizeFilterList ??
          this.filterMaterialList,
        trimSide: this.trimSide,
        /** 记录 finaldrawdata当前的title顺序 */
        beforeTitleSorts: this.beforeTitleSorts,
      }
      if (this.paibanData.length > 0) {
        obj.process_setting_id = this.ncSetting?.process_setting_id
        obj.process_setting_name = this.ncSetting?.process_setting_name
        // 避免对之前的数据产生影响，在这里深拷贝一下 全局排版打印标签需要增加标识，全局就不拷贝了
        obj.paibanData = this.isSubPrintTag
          ? cloneDeep(this.paibanData)
          : this.paibanData
        obj.paibanData.forEach((e, index) => {
          if (this.isSubPrintTag && this.currentBigpart) {
            if (e.canvasIndex === this.currentBigpart.canvasIndex) {
              obj.paibanData[index].parts = this.currentBigpart.parts
            }
          }
          obj.paibanData[index]?.parts.forEach((part) => {
            // 任意数据不相等则标识改变 板子位置数据 下刀点 切割顺序
            if (part.oriMarkBoards) {
              // 如果没有oriMarkBoards，说明是历史数据
              // 还是用0.001来做容差比较
              if (
                Math.abs(part.startX - part.oriMarkBoards.startX) >= 0.001 ||
                Math.abs(part.startY - part.oriMarkBoards.startY) >= 0.001 ||
                part.cutOrigin !== part.oriMarkBoards.cutOrigin ||
                part.priority !== part.oriMarkBoards.priority ||
                part.mark_notcare ||
                part.mark_rotation ||
                part.reverePlank
              ) {
                part.modified = true
              } else {
                part.modified = false
              }
            }
          })
        })
      }
      if (this.isShowSample) {
        obj.sampleFormData = this.sampleTableData
      }

      return { obj }
    },
    finish_percent() {
      let total = 0
      total = this.renderDataList.length
      if (!total) return 100
      if (this.exportType === 'pdf') {
        return Math.floor((this.pdfPageCount / total) * 100)
      }

      return Math.floor((this.tag_svg_list.length / total) * 100)
    },
    tag_canvas_wap_width() {
      if (!this.cur_template) return { total_width: 0, space: 0 }
      let dpi = getDeviceXDPI()
      let tag_width =
        mmToPx(this.cur_template.tag_width, dpi) * this.canvas_scale
      let space =
        mmToPx(this.print_setting.labelColumnGap, dpi) * this.canvas_scale
      return {
        total_width:
          tag_width * this.print_setting.cols +
          space * (this.print_setting.cols - 1),
        space,
      }
    },
    renderDataList() {
      if (this.need_lave || this.need_lave_surplus) {
        if (this.is_lave_tag_end || this.is_lave_tag_end_sur) {
          let finalSourceData = [...this.tagListSourceData]
          this.laveTagListSourceData.forEach((item) => {
            const plankIndex = item.plank_index
            const startIndex = finalSourceData.findIndex((i) => {
              if (i.plank_index !== plankIndex) {
                item.needRemove = true
              } else {
                item.needRemove = false
              }
              return i.plank_index == plankIndex
            })
            if (startIndex === -1) return
            const insertIndex =
              startIndex +
              finalSourceData.filter((it) => it.plank_index === plankIndex)
                .length
            // 将标准大板和余料大板分开
            if (item.plank.surplusInfo) {
              if (!this.is_lave_tag_end_sur) {
                finalSourceData.push(item)
              } else finalSourceData.splice(insertIndex, 0, item)
            } else {
              if (!this.is_lave_tag_end) {
                finalSourceData.push(item)
              } else finalSourceData.splice(insertIndex, 0, item)
            }
          })
          return finalSourceData
        } else {
          return [...this.tagListSourceData, ...this.laveTagListSourceData]
        }
      } else {
        return this.tagListSourceData
      }
    },
    disabledTagList() {
      return this.isTagLoading || this.isNoMoreTag
    },
    all_page() {
      if (this.need_lave || this.need_lave_surplus) {
        const laveTag = this.laveTagListSourceData.filter(
          (item) => !item.needRemove
        )
        return [...this.tagListSourceData, ...laveTag].length
      }
      return this.tagListSourceData.length
    },
    part_page() {
      return this.tagListSourceData.length
    },
    isWebToQt() {
      return Boolean(window.webToQt)
    },
    isNewTagDraw() {
      const ggver = sessionStorage.getItem('guigui_version') ?? ''

      const GGV = Number(
        (window.webToQt?.ggVersion ?? ggver).split('-')[0].split('.').join('')
      )
      return this.isWebToQt && GGV >= 5003
    },
    // 根据renderDataList，统计出当前一共有多少房间，并且返回一个房间名和字母/数字的一个映射关系
    roomNameMap() {
      // 筛选出tag的标签数据
      const tagDataList = this.renderDataList.filter(
        (item) => item.type === 'tag'
      )
      return roomNameToChartMap(tagDataList)
    },
    mainLoadingTip() {
      if (this.isLoadFont) {
        return this.translateLang('printPage.loadFontTip')
      } else if (this.template_loading) {
        return this.translateLang('printPage.tempLoading')
      }
      return '加载中'
    },
    indeterminateForNor() {
      const checkArr = [
        this.gen_small_plank_tag,
        this.gen_big_plank_tag,
        this.need_lave,
        this.cut_need_lave,
      ]
      const isAll = checkArr.every((item) => item)
      const isNone = checkArr.every((item) => !item)
      return !(isAll || isNone)
    },
    indeterminate() {
      const checkArr = [this.checkAllForNor, this.checkAllForSur]
      const isAll = checkArr.every((item) => item)
      const isNone = checkArr.every((item) => !item)
      return !(isAll || isNone)
    },
    indeterminateForSur() {
      const checkArr = [
        this.gen_small_plank_tag_surplus,
        this.gen_big_plank_surplus_tag,
        this.need_lave_surplus,
        this.cut_need_lave_surplus,
      ]
      const isAll = checkArr.every((item) => item)
      const isNone = checkArr.every((item) => !item)
      return !(isAll || isNone)
    },
    checkAll() {
      return this.checkAllForNor && this.checkAllForSur
    },
    checkAllForNor() {
      return (
        this.gen_small_plank_tag &&
        this.gen_big_plank_tag &&
        this.need_lave &&
        this.cut_need_lave
      )
    },
    checkAllForSur() {
      return (
        this.gen_small_plank_tag_surplus &&
        this.gen_big_plank_surplus_tag &&
        this.need_lave_surplus &&
        this.cut_need_lave_surplus
      )
    },
    dualLanguageOptions() {
      return getDualLanguageOptions()
    },
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.params.bigpart && this.$route.params.bigpart.stockNum) {
          this.currentBigpart = this.$route.params.bigpart
        } else {
          this.currentBigpart = null
        }
        // if (this.$route.path == '/printTag' && this.$route.query.from) {
        //   this.isPaibanDataChange = true
        //   this.resetRequest()
        // }
      },
    },
    '$store.state.ncSetting.front_labeling_start_num': {
      handler() {
        if (this.isPaibanDataChange) {
          this.currentBigpart = null
        }
        this.initData()
        this.initLaveData()
        this.startRender()
      },
    },
    // 通用设置的余料标签是否展示会重新渲染
    '$store.state.preferencesSetting.setting.isSurpLabelSetValue': {
      handler() {
        if (this.isPaibanDataChange) {
          this.currentBigpart = null
        }
        this.initLaveData()
        this.laveTagListSourceData = []
        this.startRender()
      },
    },
    // 通用设置的余料标签面积阈值是否展示会重新渲染
    '$store.state.preferencesSetting.setting.surpLabelSetValue': {
      handler() {
        if (this.isPaibanDataChange) {
          this.currentBigpart = null
        }
        if (this.$store.state.preferencesSetting.setting?.isSurpLabelSetValue) {
          this.initLaveData()
          this.laveTagListSourceData = []
          this.startRender()
        }
      },
    },
    // ncSetting的标签模板 id 变更时重新渲染
    '$route.path': {
      handler(val) {
        if (val.includes('printTag')) {
          const tagTempId = this.$store.state.ncSetting.tag_template_id
          if (tagTempId >= 0 && this.active_template_id >= 0) {
            const templateIndex = this.template_list.findIndex(
              (item) => item.id === tagTempId
            )
            if (templateIndex !== -1) {
              if (tagTempId != this.active_template_id) {
                const template = this.template_list[templateIndex]
                this.chooseTemplate(template)
              } else {
                this.$nextTick(() => {
                  this.$refs['tagTempListRef'].scrollTo({
                    top: templateIndex * 34 < 0 ? 0 : templateIndex * 34,
                    behavior: 'smooth',
                  })
                })
              }
            }
          }
        }
      },
    },
  },
  async created() {
    // todo 这是一个临时处理，用于临时修复标签会加载两次的问题,只是减少触发的几率
    // this.startRender = debounce(this._startRender, 1000)
    this.loadTagList = debounce(this._loadTagList, 1000)
    this.resetRequest()
  },
  async mounted() {
    if (window.webToQt) {
      this.inQt = true
    } else {
      this.inQt = false
    }

    if (this.$route.params.bigpart && this.$route.params.bigpart.stockNum) {
      this.currentBigpart = this.$route.params.bigpart
    }
    // parintTag2-error-circle 鼠标悬浮时显示提示
    let error_circle = document.getElementById('parintTag2-error-circle')
    // 添加鼠标悬停事件监听
    error_circle.addEventListener('mouseover', this.handleShowTip)
    error_circle.addEventListener('mouseout', this.handleCloseTip)
    // 首次进入的时候，需要判断语言更新
    this.exportLanguage = this.$store.state.exportLanguage ?? Lang.state.lang
    this.updateLocalLanguage()
    EventBus.$on(EventBusKey.TRANSLATE, this.updateTemplate)
  },
  beforeDestroy() {
    // this.removeBusEvent()
    EventBus.$off(EventBusKey.TRANSLATE, this.updateTemplate)
  },
  // 模板编辑退出刷新页面
  beforeRouteEnter(to, from, next) {
    if (from.name == 'editTagTem') {
      next((vm) => {
        vm.isPaibanDataChange = true
        vm.resetRequest()
      })
    }
    next(true)
  },
  // 1、点击了重新排版会生成新的排版号
  // 2、点击打印标签，需要判断paibanData是否发生过变化，发生变化了：需要重新调取排版批次---未发生变化：则不调取接口生成排版批次号

  async activated() {
    // 挂载偏好设置的更新
    this.$preference.init(this.updatePreference, this.$route.path)
    await this.addFont()
    this.isInCurrentRoute = true
    // this.isCanDownLoading = true
    // paibanData与afterPaibanData比较时 忽略掉isActive(大板选中状态)、isLocked(大板锁定状态)等变化
    const ignoreKeys = ['isActive', 'isLocked', '_sortNum']
    const replacer = (key, value) =>
      ignoreKeys.includes(key) ? undefined : value
    /**
     * 1、排版变化
     * 2、批量补标签（第二次补标签时不生效，因此增加这个判断）且非切换左侧导航栏标签管理进入（不增加这个且，补标签之后又从标签管理进入标签，会出现一直在加载中的bug）
     * 3、排版页头部打印标签按钮（不管补没补标签都加载全部标签），在清空补标签数据后
     * 就进行重新绘制
     */
    const storedPaiban = this.afterPaibanData
    const currentPaiban = this.$store.state.paibanData
    const hasPaibanChanged =
      storedPaiban && storedPaiban.length
        ? !isEqual(currentPaiban, storedPaiban)
        : false
    const needInitBatch =
      !this.$store.state.typesettingBatch && this.$route.query.from !== 'temp'
    if (hasPaibanChanged) {
      this.getBatch()
    } else if (needInitBatch) {
      this.getBatch()
    }
    const isPaibanDataChange =
      JSON.stringify(this.$store.state.paibanData, replacer) !==
      JSON.stringify(this.afterPaibanData, replacer)
    if (isPaibanDataChange) {
      this.afterPaibanData = cloneDeep(this.$store.state.paibanData)
    }
    if (
      isPaibanDataChange ||
      (this.batchTaggingList.length && this.$route.query.from !== 'temp') ||
      this.$route.params.isLoadAllTag
    ) {
      this.isSameTypeSet = false
      this.resetRequest()
      this.isPaibanDataChange = true
    } else {
      // 如果是当前模板
      this.isSameTypeSet = true
      if (!this.isNoMoreTag) {
        // 如果没有下载完，继续加载
        this.loadTagList(false, true)
      }
    }
  },
  async deactivated() {
    this.isInCurrentRoute = false
    // 无权限使用中英双语，恢复操作
    if (!(await this.checkIsExport(false))) {
      this.roomCabinetPanelNameDisplay = false
      this.saveConf()
    }
  },
  components: {
    breadcrumb,
    loading,
    GBaseModal,
    GFolderChooseModal,
    GPaidFeature,
    newContent,
  },
}
</script>

<style lang="less">
.print_tag_wapper {
  min-height: calc(100vh - 60px);
  background-color: #eeeeee;

  .breadcrumb-box {
    position: relative;
    z-index: 1;
    height: 46px;
    padding: 0 !important;

    .bread-crumb-box {
      display: flex;
      align-items: center;
      height: 46px !important;
      background-color: #eee !important;

      .ant-breadcrumb {
        padding: 0 !important;
        padding-left: 16px !important;
        margin-top: 2px !important;
      }
    }

    .bread-crumb-box .bread-crumb-box-content {
      display: none !important;
    }

    .select-tag {
      position: absolute;
      bottom: 10px;
      left: 320px;
      display: flex;
      align-items: center;

      .el-icon-loading {
        margin-left: 5px;
        color: #18a8c7;
        font-size: 16px;
      }

      .progress {
        display: block;
        width: 180px;
        margin-left: 5px;
      }
    }
  }

  .com_content {
    display: flex;
    width: 100%;

    .tag_setTem_wap {
      width: 280px;
      height: calc(100vh - 183px);
      overflow-x: hidden;
      background-color: #fff;

      > div {
        padding: 16px 0px 0px 16px;

        .title {
          display: flex;
          align-items: center;
          font-weight: bold;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.9);
        }
      }

      .tag_tem_wap {
        height: 250px;
        border-bottom: 1px solid #e7e7e7;

        .tag_tem_list {
          max-height: 140px;
          overflow-x: hidden;

          > div {
            height: 34px;
            padding-left: 42px;
            padding-right: 8px;
            line-height: 34px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            &.active {
              color: rgba(0, 0, 0, 0.9);
              position: relative;

              &::before {
                position: absolute;
                left: 16px;
                top: 9px;
                content: '';
                width: 16px;
                height: 16px;
                background: url('~@/assets/icon/check@2x.png') no-repeat center;
                background-size: 16px;
              }
            }

            &:hover {
              background-color: #f3f3f3;
              border-radius: 4px;
              color: rgba(0, 0, 0, 0.6);
            }
          }

          .template-name {
            display: block;
            white-space: nowrap;
            flex: 1;
            min-width: 0;
            width: auto;
          }

          .template-action-btn {
            width: 28px;
            height: 28px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin-left: 8px;
            color: rgba(0, 0, 0, 0.45);
            background: rgba(0, 0, 0, 0.04);
            border: 1px solid transparent;
            border-radius: 50%;
            cursor: pointer;
            transition: all 0.2s ease;

            &:hover {
              color: #1677ff;
              background: rgba(22, 119, 255, 0.1);
              border-color: rgba(22, 119, 255, 0.22);
            }

            .anticon {
              font-size: 14px;
            }
          }
        }
      }

      .tag_set {
        border-bottom: 1px solid #e7e7e7;

        .ant-checkbox-wrapper {
          color: rgba(0, 0, 0, 0.9);
          display: flex;
          align-items: center;
          margin-bottom: 16px;
        }

        .ant-checkbox-wrapper + .ant-checkbox-wrapper {
          margin-left: 0px;
        }

        > div > p {
          margin-bottom: 16px;
        }

        .tag_gen {
          display: flex;
          justify-content: space-between;
        }

        .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
          height: 32px;
          width: 120px;
          line-height: 32px;
        }
      }

      .label-position {
        margin-left: 24px;
        font-size: 12px !important;

        .coord-box {
          width: 105px;
          height: 26px;
          border: 1px solid #dcdcdc;
        }

        .ant-input-number {
          border: none;
          box-shadow: none;

          &:focus {
            box-shadow: none;
          }
        }

        .ant-input-number-input {
          height: 24px;
          padding-top: 1px;
        }

        .el-input-number {
          width: 60px !important;
          margin-left: 2px !important;
        }

        .el-input-number__decrease,
        .el-input-number__increase {
          width: 20px !important;
        }

        .el-input__inner {
          padding-right: 20px !important;
          padding-left: 0 !important;
          font-size: 12px !important;
        }
      }

      .tag_sort_check {
        margin-bottom: 16px;

        .ant-radio-wrapper {
          margin-right: 0;
          text-overflow: ellipsis;
          overflow: hidden;
          max-width: 75px;
          height: 30px;
          display: flex;
          align-items: center;

          span {
            display: inline-block;
          }

          span.ant-radio + * {
            display: flex;
            padding-right: 12px;
            color: rgba(0, 0, 0, 0.9);
          }
        }
      }

      .tag_color_check {
        margin-bottom: 16px;

        .label-color-pop {
          width: 320px;
          min-height: 520px;
          max-height: 550px;
          flex-shrink: 0;
          border-radius: 3px;
          box-shadow: 0 6px 30px 5px #0000000d, 0 16px 24px 2px #0000000a,
            0 8px 10px -5px #00000014;
          z-index: 999;
          background-color: #fff;
          top: 165px;
          left: 160px;
          display: none;
          overflow-y: scroll;
          scrollbar-width: none;
          /* Firefox */
          -ms-overflow-style: none;

          .label-color-phead {
            color: #000000e6;
          }

          .label-color-title {
            line-height: 22px;
          }

          .label-color-span {
            display: inline-block;
            width: 133px;
            line-height: 20px;
            color: #00000066;
          }

          .label-color-img {
            width: 139px;
            height: 88px;
            margin-left: 16px;
          }
        }

        &::-webkit-scrollbar {
          display: none;
        }
      }

      .print_set {
        .ant-input-number {
          border-radius: 3px;
          border: 1px solid #dcdcdc;
        }

        .ant-slider {
          .ant-slider-track {
            background-color: #18a8c7;
          }

          .ant-slider-handle {
            border-color: #18a8c7;
          }
        }
      }
    }

    .tag-tree {
      position: relative;

      .tree {
        width: 100%;
      }
    }

    .tag_canvas_wap {
      position: relative;
      flex: 1;
      max-height: calc(100vh - 183px);
      padding: 10px;
      overflow: auto;
      text-align: center;
      background-color: #eee;

      &.tag_canvas_wap--height {
        // 主要是为了防止页面loading由于滚动条造成的跳动
        .loading_page-wrap,
        .tag_list {
          min-height: calc(100% + 100px);
        }
      }
    }

    .tag_canvas_tip {
      margin-top: calc((100vh - 183px) / 2);
    }

    .tag_list {
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      color: rgba(0, 0, 0, 1) !important;
    }

    .tag_canvas_wap > div {
      margin: 0 auto;
    }

    .tag_print_box {
      position: relative;
      width: 256px;
      height: 320px;
      background-color: #d9d9d9;
      border: 1px solid rgba(255, 255, 255, 0.9);

      .text-content {
        padding: 8px;
        background-color: #fff;
      }

      .explain {
        padding: 20px 12px;
      }

      .region {
        height: 8px;
        background-color: #eee;
      }

      .legend {
        .icon {
          display: inline-block;
          width: 24px;
          height: 24px;
          text-align: center;
        }

        .open {
          line-height: 24px;
          border: 1px solid #fff;
          border-radius: 50%;
        }
      }

      .print_btn {
        position: absolute;
        bottom: 20px;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        width: 100%;
        height: 140px;
        padding: 0 30px;
      }

      .percent_box {
        position: absolute;
        bottom: 180px;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        width: 100%;
        height: 100px;
        padding: 0 50px;
      }
    }

    .render_svg_item {
      transform-origin: left top;
    }

    .ant-radio-group {
      margin-right: 0px;
    }
  }

  .header {
    height: 77px;
    border-bottom: 1px solid #e7e7e7;

    .title {
      margin-right: 200px;
    }

    .progress {
      display: block;
      width: 180px;
      margin-left: 5px;
    }

    &-right {
      right: 24px;

      .export-btn {
        height: 34px;
        border-radius: 6px;
      }

      .export-pdf-btn:not([disabled='disabled']) {
        background-color: #18a8c7;
        color: #fff;
      }

      .print-btn {
        width: 60px;
        height: 34px;
        background-color: #18a8c7;
        border-radius: 6px;
        line-height: 32px;
        color: rgba(255, 255, 255, 0.9);
        border: none;
      }
    }
  }

  .print-tip {
    width: 320px;
    height: 76px;
    border-radius: 3px;
    background-color: #fff;
    box-shadow: 0 6px 30px 5px #0000000d, 0 16px 24px 2px #0000000a,
      0 8px 10px -5px #00000014;
    padding: 16px;
    top: 45px;
    right: -15px;
    z-index: 999;
    pointer-events: none;
    display: none;

    .color-tip {
      line-height: 22px;
      white-space: wrap;
    }
  }

  .print-tag-img:hover + .print-tip {
    display: block;
  }

  .disabled-btn {
    color: #999 !important;
    background-color: #f3f0f0 !important;

    &:hover {
      color: #999 !important;
      background-color: #f3f0f0 !important;
    }
  }
}

.text-style {
  max-width: 200px;
  line-height: 100%;
  font-weight: normal;
}

.template-action-popover {
  .ant-popover-inner {
    border-radius: 12px;
    box-shadow: 0 10px 28px rgba(15, 35, 95, 0.12);
  }
}
.ant-popover-inner-content {
  padding: 8px 10px;
}

.template-action-popover {
  .template-action-item {
    min-width: 120px;
    height: 36px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 10px;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.78);
    border-radius: 8px;
    transition: all 0.2s ease;

    .anticon {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
    }

    &:hover {
      background: #f5f8ff;
      color: #1677ff;

      .anticon {
        color: #1677ff;
      }
    }

    & + .template-action-item {
      margin-top: 4px;
    }

    &--danger {
      &:hover {
        background: #fff2f0;
        color: #ff4d4f;
      }

      &:hover .anticon {
        color: #ff4d4f;
      }
    }
  }
}

.import-template-modal {
  .import-template-tip {
    margin-bottom: 8px;
    color: rgba(0, 0, 0, 0.65);
  }

  .import-template-error {
    margin-top: 8px;
    color: #f5222d;
  }
}
</style>
<style lang="less" scoped>
/deep/ .new-button_text {
  right: -35px;
}
</style>
